import React, {useEffect, useRef, useState} from "react";
import "./posnew.css";
import {apiUrl} from "../../../setting";
import {getMainMenuUrl} from "../../mainmenu/api";
import PageHeader from "../../../components/Elements/pageHeader";
import {
    OrderPaymentFxn,
    TransferTableFxn,
    addOrderFxn,
    editKotFxn,
    getCouponDisFxn,
    getOldKotFxn,
    getPrintProductsFxn,
    groupedProductFxn,
    saveOrderFxn,
    tableListFxn,
    TransferKotFxn,
    MergeTableFxn,
    TransferKotItemFxn, getSingleOrderFxn
} from "../actions";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import _, {size, toArray} from "lodash";
import Modal from "../../../components/Elements/Modal";
import Image from "../iconss.png";
import {
    Card, InputBox, notification, Form, Drawer,
} from "../../../components/Elements/appUtils";
import {FetchSpecialNotes} from "../actions";
import {
    getItemLocalstorage, getVegStatus,
} from "../../../components/_utils/_utils";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import moment from "moment";
import AddCustomerDrawerPos from "../../../components/addCustomerDrawerPos";
import {category, TABLE_MAP} from "../../../components/_utils/appUtils";
import {updateKotStatusFxn, updatePriorityFxn} from "../../kot/actions";
import {useReactToPrint} from "react-to-print";
import {appAxios as axios} from "../../../request";
import {getToken} from "../../../request";
import {getMainCategoryUrl} from "../../maincategory/api";
import PrintDesign from "../../print/printDesign";
import {UserRights} from "../../../components/rightComponents";


let initState = {
    subTotal: "0.00",
    totalAmount: 0,
    discountAmount: "0.00",
    serviceTaxAmount: "0.00",
    cgstAmount: "0.00",
    sgstAmount: "0.00",
    tax: "0.00",
    netAmount: "0.00",
    nonGstDiscountAmount: 0,
    gstDiscountAmount: 0,
    amountAfterDiscount: 0,
    totalTaxable: 0
};
const PosComponent = (props) => {
    let {currentUser} = props
    const userType = getItemLocalstorage("user")["userType"];
    let dispatch = useDispatch();
    const componentRef = useRef();
    let navigate = useNavigate();
    const options = {
        autoplay: false, loop: false, nav: true, dots: false, dotClass: "owl-dot", // margin: 15,
        autoplayTimeout: 2000, responsive: {
            0: {
                items: 4, nav: true,
            }, 400: {
                items: 4, nav: true,
            }, 600: {
                items: 6, nav: true,
            }, 800: {
                items: 6, nav: true, loop: false,
            }, 1200: {
                items: 8, nav: true, loop: false,
            },
        },
    };
    const [selectedMainCategory, setSelectedMainCategory] = useState("");
    const [mainMenuOptions, setMainMenuOptions] = useState([]);
    const [selectedMainMenu, setSelectedMainMenu] = useState("");
    let [productList, setProductList] = useState([]);
    let [filteredProducts, setFilteredProducts] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    let [activeIndex, setActiveIndex] = useState(0);
    let [selectedProducts, setSelectedProducts] = useState([]);
    let [OldKots, setOldKots] = useState([]);
    let [noOfKots, setNoOfKots] = useState(0);
    let [menuName, setMenuName] = useState("");
    let [allData, setAllData] = useState([]);
    let [OldKotTotalAmount, setOldKotTotalAmount] = useState(0);
    let [totalProductsLength, setTotalProductsLength] = useState("");
    let [orderId, setOrderId] = useState("");
    let [formData, setFormData] = useState({});
    let [editdata, seteditData] = useState({});
    let [tableNo, setTableNo] = useState("");
    let [state, setState] = useState(initState);
    let [isModalOpen, setIsModalOpen] = useState(false);
    let [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
    let [isDiscountModalOpen, setIsDiscountModalOpen] = useState(false);
    let [isOldkotModalOpen, setIsOldkotModalOpen] = useState(false);
    const [isAllKotItemsModalOpen, setIsAllKotItemsModalOpen] = useState(false);
    let [isSpecialNoteModalOpen, setIsSpecialNoteModalOpen] = useState(false);
    let [isTransferTableModalOpen, setisTransferTableModalOpen] = useState(false);
    let [editKotModal, setEditKotModal] = useState(false);
    let [kotId, setKotId] = useState("");
    let [editKotProducts, setEditKotProducts] = useState([]);
    let [refreshKey, setRefreshKey] = useState(moment());
    let [variantData, setVariantData] = useState({});
    let [bgIndex, setBgIndex] = useState(null);
    let [currentStatus, setCurrentStatus] = useState("");
    let [productIds, setProductIds] = useState("");
    let [varient, setvarient] = useState("");
    const [searchSuggestions, setSearchSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [kotPrintData, setKotPrintData] = useState(null);
    const [savedKotProducts, setSavedKotProducts] = useState([]);
    const [savedOrderSummary, setSavedOrderSummary] = useState(null);
    const [manualNote, setmanualNote] = useState("")
    const [isTransferKotModalOpen, setIsTransferKotModalOpen] = useState(false);
    const [transferKotData, setTransferKotData] = useState({
        orderId: "", kotId: "",
    });
    const [transferKotTableName, setTransferKotTableName] = useState("");
    const [transferKotTableNumber, setTransferKotTableNumber] = useState("");
    const [transferKotTableNumbers, setTransferKotTableNumbers] = useState([]);
    const [isMergeTableModalOpen, setIsMergeTableModalOpen] = useState(false);
    const [runningTables, setRunningTables] = useState([]);
    const [selectedMergeTable, setSelectedMergeTable] = useState("");
    const [selectedPaymentInputs, setSelectedPaymentInputs] = useState([]);
    const [manualPaymentInputs, setManualPaymentInputs] = useState([]);
    const [selectedPaymentType, setSelectedPaymentType] = useState("");
    const [isComplementaryBill, setIsComplementaryBill] = useState(false);
    const [isComplementaryReasonModalOpen, setIsComplementaryReasonModalOpen] = useState(false);
    const [complementaryReason, setComplementaryReason] = useState("");
    const [showComplementaryButton, setShowComplementaryButton] = useState(false);
    const [isMoveItemModalOpen, setIsMoveItemModalOpen] = useState(false);
    const [moveItemData, setMoveItemData] = useState({});
    const [moveItemQty, setMoveItemQty] = useState(1);
    const [moveItemTableName, setMoveItemTableName] = useState("");
    const [moveItemTableNumber, setMoveItemTableNumber] = useState("");
    const [moveItemTableNumbers, setMoveItemTableNumbers] = useState([]);
    const canShowTransferMerge = orderId && currentStatus !== "Done" && currentStatus !== "Paid" && currentStatus !== "Credit";
    const canShowMoveItem =
        orderId &&
        currentStatus === "Pending";
    let [specialNoteList, setspecialNoteList] = useState([]);
    let [customerState, setCustomerState] = useState({
        visible: false, lead: {},
    });
    let [choosePaxDrawer, setChoosePaxDrawer] = useState({
        visible: false,
    });
    let [singleOrderData, setSingleOrderData] = useState({});
    let [paxLength, setPaxLength] = useState(0);
    const [discountType, setDiscountType] = useState("discount");
    const handleDiscountChange = (value) => {
        setDiscountType(value);
    };
    const [dynamicMainCategories, setDynamicMainCategories] = useState([]);
    const [discountper, setdiscountper] = useState("");
    const [couponCode, setCouponCode] = useState("");
    const [disCouponCode, setDisCouponCode] = useState("");
    const [discountCoupon, setDiscountCoupon] = useState("");
    const [couponId, setCouponId] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [customerMobile, setCustomerMobile] = useState("");
    const [customerEmail, setCustomerEmail] = useState("");
    const [customerGst, setCustomerGst] = useState("");
    const [notes, setNotes] = useState("");
    const [tableName, setTableName] = useState("");
    const [saveTableName, setSaveTableName] = useState("");
    const [tableNumber, setTableNumber] = useState("");
    const [serviceTaxIncluded, setServiceTaxIncluded] = useState(true);
    const [guest, setGuest] = useState(false);
    const [tableKey, setTableKey] = useState(null);
    let [clickedProId, seClickedProId] = useState("");
    const isSearchingProducts = searchTerm.trim() !== "" && filteredProducts.length > 0;
    const handleCheckboxChange = () => {
        setServiceTaxIncluded(!serviceTaxIncluded);
    };

    const [loading, setLoading] = useState(false);

    const [paymentMethod, setPaymentMethod] = useState("");
    const [paymentOption, setPaymentOption] = useState("payNow");

    const handlePaymentMethodChange = (value) => {
        setPaymentMethod(value);
    };

    let [paymentData, setPaymentData] = useState({
        PaymentType: "",
        customerPaid: 0,
        cashAmount: 0,
        upiAmount: 0,
        cardAmount: 0,
        returnToCustomer: 0,
        tip: 0,
        setteledAmount: 0,
        totalAmount: 0,
        orderNo: "",
        orderId: "",
        cashDiscount: 0,
        finalAmount: 0,
    });

    useEffect(() => {
        if (paymentData.cashDiscount) {
            let finalAmount = paymentData.totalAmount - paymentData.cashDiscount;
            setPaymentData({...paymentData, finalAmount: finalAmount});
        } else {
            setPaymentData({...paymentData, finalAmount: paymentData.totalAmount});
        }
    }, [paymentData.cashDiscount]);

    let calculatePrice = () => {
        let customerPaid = 0;
        if (paymentData && typeof paymentData === "object") {
            if (paymentData.cashAmount && !isNaN(parseFloat(paymentData.cashAmount))) {
                customerPaid += parseFloat(paymentData.cashAmount);
            }
            if (paymentData.upiAmount && !isNaN(parseFloat(paymentData.upiAmount))) {
                customerPaid += parseFloat(paymentData.upiAmount);
            }
            if (paymentData.cardAmount && !isNaN(parseFloat(paymentData.cardAmount))) {
                customerPaid += parseFloat(paymentData.cardAmount);
            }
        }
        setPaymentData({
            ...paymentData, customerPaid: customerPaid,
        });

        let returnToCustomer = 0;
        let tip = paymentData.tip || 0;
        let settledAmount = 0;

        if (tip) {
            tip = parseFloat(tip);
        }

        if (customerPaid) {
            settledAmount = parseFloat(paymentData.finalAmount + tip).toFixed(2);
        }
        returnToCustomer = parseFloat(customerPaid) - settledAmount;

        setPaymentData({
            ...paymentData,
            customerPaid: customerPaid,
            setteledAmount: settledAmount,
            returnToCustomer: returnToCustomer > 0 ? returnToCustomer.toFixed(2) : 0,
        });
    };

    useEffect(() => {
        let customerPaid = parseFloat(paymentData.cashAmount) + parseFloat(paymentData.cardAmount) + parseFloat(paymentData.upiAmount) || 0;
        setPaymentData({
            ...paymentData, customerPaid: customerPaid,
        });
        calculatePrice();
    }, [paymentData.cashAmount, paymentData.upiAmount, paymentData.cardAmount, paymentData.tip,]);

    let handlePayment = async () => {
        paymentData.paymentType = paymentMethod;

        if (Number(paymentData.customerPaid) !== Math.round(Number(paymentData.finalAmount || 0))) {
            notification.warning({message: "Enter Valid Paid Amount."});
            return;
        }
        delete paymentData.totalAmount;
        if (couponId && couponCode) {
            paymentData.couponId = couponId;
            paymentData.couponCode = couponCode;
        }
        // console.log(paymentData,'paymentData')
        // return
        const {
            subTotal, totalAmount, discountAmount, cgstAmount, sgstAmount, serviceTaxAmount, tax, netAmount,
        } = state;

        paymentData.subTotal = subTotal;
        paymentData.totalAmount = totalAmount;
        paymentData.discount = discountAmount;
        paymentData.cgstAmount = cgstAmount;
        paymentData.sgstAmount = sgstAmount;
        paymentData.serviceTaxAmount = serviceTaxAmount;
        paymentData.tax = tax;
        paymentData.netAmount = netAmount;
        paymentData.serviceTaxIncluded = serviceTaxIncluded;
        let x = await dispatch(OrderPaymentFxn(paymentData));
        if (x && x.success) {
            loadOrderData(paymentData.orderId);
            setPaymentData({});
            setPaymentOption("payNow");
            setIsPaymentModalOpen(false);
            setTimeout(() => {
                navigate("/tables");
            }, 1500);
        }
    };
    const handlePaymentOptionToggle = (type) => {
        let updatedInputs = [];

        if (selectedPaymentInputs.includes(type)) {
            updatedInputs = selectedPaymentInputs.filter((item) => item !== type);

            setManualPaymentInputs((prev) => prev.filter((item) => item !== type));

            setSelectedPaymentInputs(updatedInputs);

            setPaymentData((prev) => ({
                ...prev, [`${type}Amount`]: 0,
            }));

            return;
        }

        const total = Math.round(Number(paymentData.finalAmount || 0));

        const usedAmount = Number(paymentData.cashAmount || 0) + Number(paymentData.upiAmount || 0) + Number(paymentData.cardAmount || 0);

        const remaining = Math.max(total - usedAmount, 0);

        if (remaining <= 0) {
            notification.warning({
                message: "Full amount is already assigned.",
            });
            return;
        }

        updatedInputs = [...selectedPaymentInputs, type];
        setSelectedPaymentInputs(updatedInputs);

        setPaymentData((prev) => ({
            ...prev, [`${type}Amount`]: Number(remaining.toFixed(2)),
        }));
    };
    const handlePaymentInputChange = (type, value) => {
        let inputValue = Number(value || 0);
        const total = Number(paymentData.finalAmount || 0);

        if (inputValue < 0) inputValue = 0;
        if (inputValue > total) inputValue = total;

        const updatedManualInputs = manualPaymentInputs.includes(type) ? manualPaymentInputs : [...manualPaymentInputs, type];

        setManualPaymentInputs(updatedManualInputs);

        let newPaymentData = {
            ...paymentData, [`${type}Amount`]: Number(inputValue.toFixed(2)),
        };

        const usedByManual = updatedManualInputs.reduce((sum, method) => {
            return sum + Number(newPaymentData[`${method}Amount`] || 0);
        }, 0);

        let remaining = Number((total - usedByManual).toFixed(2));
        if (remaining < 0) remaining = 0;

        const autoMethods = selectedPaymentInputs.filter((method) => !updatedManualInputs.includes(method));

        autoMethods.forEach((method, index) => {
            if (index === autoMethods.length - 1) {
                newPaymentData[`${method}Amount`] = Number(remaining.toFixed(2));
            } else {
                newPaymentData[`${method}Amount`] = 0;
            }
        });

        setPaymentData(newPaymentData);
    };
    let handlePayLater = async () => {
        if (!customerName || !customerMobile) {
            notification.warning({
                message: "Please add customer before save credit bill",
            });
            return;
        }
        let creditPayload = {
            ...paymentData,
            paymentType: "Credit",
            PaymentType: "Credit",
            customerPaid: 0,
            cashAmount: 0,
            upiAmount: 0,
            cardAmount: 0,
            returnToCustomer: 0,
            tip: 0,
            setteledAmount: 0,
            cashDiscount: 0,
            finalAmount: state.netAmount,
            customerName: customerName,
            customerMobile: customerMobile,
            customerEmail: customerEmail,
            customerGst: customerGst,
        };

        if (couponId && couponCode) {
            creditPayload.couponId = couponId;
            creditPayload.couponCode = couponCode;
        }

        const {
            subTotal, totalAmount, discountAmount, cgstAmount, sgstAmount, serviceTaxAmount, tax, netAmount,
        } = state;

        creditPayload.subTotal = subTotal;
        creditPayload.totalAmount = totalAmount;
        creditPayload.discount = discountAmount;
        creditPayload.cgstAmount = cgstAmount;
        creditPayload.sgstAmount = sgstAmount;
        creditPayload.serviceTaxAmount = serviceTaxAmount;
        creditPayload.tax = tax;
        creditPayload.netAmount = netAmount;
        creditPayload.serviceTaxIncluded = serviceTaxIncluded;

        let x = await dispatch(OrderPaymentFxn(creditPayload));
        if (x && x.success) {
            setPaymentData({});
            setPaymentOption("payNow");
            setIsPaymentModalOpen(false);
            setTimeout(() => {
                navigate("/tables");
            }, 1500);
        }
    };
    let loadTransferKotTableNumbers = async (tableName) => {
        let {data} = await tableListFxn();
        let filtered = {};

        if (tableName) {
            let filteredArray = data.filter((item) => item.name === tableName);
            if (filteredArray.length > 0) {
                filtered = filteredArray[0];
            }
        }

        if (filtered.tables) {
            let allTableNumber = filtered.tables;
            setTransferKotTableNumbers(allTableNumber);
        }
    };
    useEffect(() => {
        if (transferKotTableName) {
            loadTransferKotTableNumbers(transferKotTableName);
        } else {
            setTransferKotTableNumbers([]);
            setTransferKotTableNumber("");
        }
    }, [transferKotTableName]);
    let loadMoveItemTableNumbers = async (tableName) => {
        let {data} = await tableListFxn();
        let filtered = {};

        if (tableName) {
            let filteredArray = data.filter((item) => item.name === tableName);
            if (filteredArray.length > 0) {
                filtered = filteredArray[0];
            }
        }

        if (filtered.tables) {
            setMoveItemTableNumbers(filtered.tables);
        }
    };

    useEffect(() => {
        if (moveItemTableName) {
            loadMoveItemTableNumbers(moveItemTableName);
        } else {
            setMoveItemTableNumbers([]);
            setMoveItemTableNumber("");
        }
    }, [moveItemTableName]);
    let loadRunningTables = async () => {
        let {data} = await tableListFxn();

        const allTables = (data || []).flatMap((section) => (section.tables || []).map((table) => ({
            ...table, tableGroupName: section.name,
        })));

        const activeTables = allTables.filter((item) => {
            return (item.orderId && Number(item.totalAmount || 0) > 0 && String(item.status || "").toLowerCase() === "pending" && String(item.key || "") !== String(tableNo));
        });
        setRunningTables(activeTables);
    };
    let mergeTable = async () => {
        if (!orderId) {
            notification.warning({message: "Order not found."});
            return;
        }

        if (!selectedMergeTable) {
            notification.warning({message: "Please select running table."});
            return;
        }

        let x = await dispatch(MergeTableFxn({
            fromOrderId: orderId, toTableNo: selectedMergeTable,
        }));

        if (x && !x.error) {
            const newTableNo = selectedMergeTable;
            setIsMergeTableModalOpen(false);
            setSelectedMergeTable("");
            setRunningTables([]);

            // navigate to merged table
            // navigate(`/pos/${selectedMergeTable}`);
            setTimeout(() => {
                navigate(`/pos/${newTableNo}`);
                setTableKey(new Date().toString());
            }, 500);
        }
    };
    let handlePaymentSubmit = async () => {
        if (paymentOption === "payLater") {
            handlePayLater();
            return;
        }

        handlePayment();
    };

    useEffect(() => {
        if (kotId) {
            const kot = OldKots.find((kot) => kot._id === kotId);
            if (kot) {
                setEditKotProducts(kot.products);
            }
        }
    }, [kotId]);

    //new code

    useEffect(() => {
        const allProducts = getAllBillProducts();

        if (allProducts.length > 0) {
            events.calculatePrice();
        } else {
            events._updateState(initState);
        }
    }, [selectedProducts, savedKotProducts, serviceTaxIncluded, discountper, isComplementaryBill]);
    let events = {
        showCustomerModal: (lead) => {
            setCustomerState({
                visible: true, lead: lead,
            });
        },
        hide: () => {
            setCustomerState({
                visible: false,
            });
            // events.reloadTable();
        },
        addProduct: (data) => {
            data.productId = data._id;

            delete data._id;
            let clonePro = _.clone(selectedProducts);
            let findPro = _.find(clonePro, (item) => {
                if (item.productId == data.productId && item.price == data.price) {
                    return item.productId == data.productId;
                } else if (item.productId == data.productId && item.price != data.price) {
                    return null;
                }
            });
            if (findPro) {
                findPro.quantity = findPro.quantity + 1;
                findPro.totalAmount = findPro.quantity * parseFloat(findPro.price);
            } else {
                clonePro.push({...data, quantity: 1, totalAmount: data.price});
            }
            setTimeout(() => {
                seClickedProId("");
            }, 200);
            setSelectedProducts(clonePro);
        },
        incQty: (data) => {
            let clonePro = _.clone(selectedProducts);
            let findPro = _.find(clonePro, (item) => {
                return item.productId == data.productId && item.price == data.price;
            });
            if (findPro) {
                findPro.quantity = findPro.quantity + 1;
                findPro.totalAmount = findPro.quantity * parseFloat(findPro.price);
            }
            setSelectedProducts(clonePro);
        },
        descQty: (data) => {
            let clonePro = _.clone(selectedProducts);
            let findPro = _.find(clonePro, (item) => {
                return item.productId == data.productId && item.price == data.price;
            });
            if (findPro) {
                findPro.quantity = findPro.quantity - 1;
                findPro.totalAmount = findPro.quantity * parseFloat(findPro.price);
            }
            if (findPro.quantity == 0) {

                const updatedProducts = _.reject(clonePro, (item) => {
                    return item.productId == data.productId && item.price == data.price;
                });
                setSelectedProducts(updatedProducts);
            } else {
                setSelectedProducts(clonePro);
            }
        },
        _updateState: (data) => {
            setState((prevState) => {
                return {
                    ...prevState, ...data,
                };
            });
        },
        calculatePriceOld: () => {
            let clonePro = getAllBillProducts();
            let discount = discountper ? Number(discountper) : 0;
            let gst = 5;
            let servicetax = serviceTaxIncluded === true ? 5 : 0;

            let cgst = gst / 2;
            let sgst = gst / 2;
            let subTotal = 0;
            let totalAmount = 0;
            let gstApplicableAmount = 0;
            let discountApplicableAmount = 0;
            let gstAndDiscountApplicableAmount = 0;
            let discountAmount = 0;
            let serviceTaxAmount = 0;
            let cgstAmount = 0;
            let sgstAmount = 0;
            let tax = 0;
            let netAmount = 0;

            _.each(clonePro, (item) => {
                let amount = parseFloat(item.price || 0) * (item.quantity ? item.quantity : 1);

                totalAmount += amount;
                subTotal += amount;

                // const isGstApplicable =
                //     (item.categoryId && item.categoryId.gst === true) ||
                //     item.gst === true;
                //new code
                const isGstApplicable = typeof item.gst === "boolean" ? item.gst : item.categoryId?.gst === true;
                // new code

                const isDiscountApplicable =
                    (item.categoryId && item.categoryId.discount === true) ||
                    item.discount === true ||
                    item.discount === 1;
                // const isDiscountApplicable = item.categoryId?.discount === true;

                if (isGstApplicable) {
                    gstApplicableAmount += amount;
                }

                if (isDiscountApplicable) {
                    discountApplicableAmount += amount;
                }

                if (isGstApplicable && isDiscountApplicable) {
                    gstAndDiscountApplicableAmount += amount;
                }
            });

            if (discount) {
                discountAmount = (discountApplicableAmount * discount) / 100;
            }

            let discountedAmount = totalAmount - discountAmount;

            let discountedGstApplicableAmount = gstApplicableAmount;
            if (discount && totalAmount > 0) {
                let gstDiscountAmount = (gstAndDiscountApplicableAmount * discount) / 100;

                discountedGstApplicableAmount = gstApplicableAmount - gstDiscountAmount;
            }

            serviceTaxAmount = (discountedGstApplicableAmount * servicetax) / 100;
            cgstAmount = (discountedGstApplicableAmount * cgst) / 100;
            sgstAmount = (discountedGstApplicableAmount * sgst) / 100;
            //new code
            if (isComplementaryBill) {
                serviceTaxAmount = 0;
                cgstAmount = 0;
                sgstAmount = 0;
            }
            //new code
            tax = serviceTaxAmount + cgstAmount + sgstAmount;
            netAmount = discountedAmount + tax;


            events._updateState({
                subTotal: subTotal.toFixed(2),
                totalAmount: parseFloat(totalAmount.toFixed(2)),
                discountAmount: discountAmount.toFixed(2),
                cgstAmount: cgstAmount.toFixed(2),
                sgstAmount: sgstAmount.toFixed(2),
                serviceTaxAmount: serviceTaxAmount.toFixed(2),
                tax: tax.toFixed(2),
                netAmount: netAmount.toFixed(2),
            });
        },
        calculatePrice: () => {
            let clonePro = getAllBillProducts();
            let discount = discountper ? Number(discountper) : 0;
            let gst = 5;
            let servicetax = serviceTaxIncluded === true ? 5 : 0;
            let cgst = gst / 2;
            let sgst = gst / 2;
            let subTotal = 0;
            let totalAmount = 0;
            let gstApplicableAmount = 0;
            let nonGstApplicableAmount = 0;
            let discountApplicableAmount = 0;
            let gstAndDiscountApplicableAmount = 0;
            let nonGstAndDiscountApplicableAmount = 0;
            let discountAmount = 0;
            let serviceTaxAmount = 0;
            let cgstAmount = 0;
            let sgstAmount = 0;
            let tax = 0;
            let netAmount = 0;
            let gstDiscountAmount = 0
            let nonGstDiscountAmount = 0
            _.each(clonePro, (item) => {
                let amount = parseFloat(item.price || 0) * (item.quantity ? item.quantity : 1);
                totalAmount += amount;
                subTotal += amount;

                const isGstApplicable = typeof item.gst === "boolean" ? item.gst : item.categoryId?.gst === true;
                // new code
                const isDiscountApplicable =
                    (item.categoryId && item.categoryId.discount === true) ||
                    item.discount === true ||
                    item.discount === 1;
                // const isDiscountApplicable = item.categoryId?.discount === true;
                if (isGstApplicable) {
                    gstApplicableAmount += amount; // taxable amount
                } else {
                    nonGstApplicableAmount += amount;
                }
                if (isDiscountApplicable) {
                    discountApplicableAmount += amount; // discounted amount

                    if (isGstApplicable) {
                        gstAndDiscountApplicableAmount += amount; // taxable amount
                    } else {
                        nonGstAndDiscountApplicableAmount += amount;
                    }
                }

            });
            if (discount) {
                discountAmount = (discountApplicableAmount * discount) / 100; // calculate total discount amount
            }
            let discountedAmount = totalAmount - discountAmount; // amount after discount
            let taxableAmount = gstApplicableAmount;
            let nonTaxableAmount = nonGstApplicableAmount;

            if (discount && totalAmount > 0) {
                gstDiscountAmount = (gstAndDiscountApplicableAmount * discount) / 100; //  discount amount on gst products
                taxableAmount = gstApplicableAmount - gstDiscountAmount; // final taxable amount after gst discount


                nonGstDiscountAmount = (nonGstAndDiscountApplicableAmount * discount) / 100; //  discount amount on gst products
                nonTaxableAmount = nonGstApplicableAmount - nonGstDiscountAmount; // final taxable amount after gst discount
            }

            serviceTaxAmount = (discountedAmount * servicetax) / 100;
            let totalTaxable = (serviceTaxAmount + taxableAmount)
            cgstAmount = (totalTaxable * cgst) / 100;
            sgstAmount = (totalTaxable * sgst) / 100;
            // sgstAmount = (taxableAmount * sgst) / 100;
            // sgstAmount = (taxableAmount * sgst) / 100;
            //new code
            if (isComplementaryBill) {
                serviceTaxAmount = 0;
                cgstAmount = 0;
                sgstAmount = 0;
            }
            //new code
            tax = serviceTaxAmount + cgstAmount + sgstAmount;
            netAmount = discountedAmount + tax;

            events._updateState({
                subTotal: subTotal.toFixed(2),
                totalAmount: parseFloat(totalAmount.toFixed(2)),
                amountAfterDiscount: discountedAmount.toFixed(2),
                discountAmount: discountAmount.toFixed(2),
                taxableAmount: taxableAmount.toFixed(2),
                nonTaxableAmount: nonTaxableAmount.toFixed(2),
                cgstAmount: cgstAmount.toFixed(2),
                sgstAmount: sgstAmount.toFixed(2),
                serviceTaxAmount: serviceTaxAmount.toFixed(2),
                tax: tax.toFixed(2),
                netAmount: netAmount.toFixed(2),
                gstDiscountAmount: gstDiscountAmount.toFixed(2),
                nonGstDiscountAmount: nonGstDiscountAmount.toFixed(2),
                totalTaxable: totalTaxable.toFixed(2)
            });
        },
        updatePriority: async (data, productId = "") => {
            let {
                message, success, data: kotData,
            } = await updatePriorityFxn({
                productId, kotId: data._id,
            });
            if (success && productId) {
                notification.warning({message: message});
            }
        },
        refreshKot: (data) => {
            let cloneData = _.clone(OldKots);
            let findKot = _.find(cloneData, (item) => {
                return item._id === data._id;
            });

            if (findKot) {
                findKot.products = data.products;
                setOldKots(cloneData);
            }
        },
        incEditQty: (data) => {
            let clonePro = _.clone(editKotProducts);
            let findPro = _.find(clonePro, (item) => {
                return (item.productId._id == data.productId._id && item.price == data.price);
            });
            if (findPro) {
                findPro.quantity = findPro.quantity + 1;
                findPro.totalAmount = findPro.quantity * parseFloat(findPro.price);
            }
            setEditKotProducts(clonePro);
        },
        desEditcQty: (data) => {
            let clonePro = _.clone(editKotProducts);
            let findPro = _.find(clonePro, (item) => {
                return (item.productId._id == data.productId._id && item.price == data.price);
            });
            if (findPro) {
                findPro.quantity = findPro.quantity - 1;
                findPro.totalAmount = findPro.quantity * parseFloat(findPro.price);
            }
            if (findPro.quantity == 0) {
                editKotProducts = _.reject(clonePro, (item) => {
                    return (item.productId._id == data.productId._id && item.price == data.price);
                });
                setEditKotProducts(editKotProducts);
            } else {
                setEditKotProducts(clonePro);
            }
        },
        getCouponDis: async () => {
            if (customerName) {
                let resp = await dispatch(getCouponDisFxn({
                    couponCode: disCouponCode, mobileNo: customerMobile,
                }),);
                if (resp && resp.success) {
                    setdiscountper(resp.result.discount);
                    setCouponCode(resp.result.couponCode);
                    setDisCouponCode("");
                    setCouponId(resp.result._id);
                } else {
                    setdiscountper("");
                    setDisCouponCode("");
                }
            } else {
                notification.warning({message: "Please choose Customer"});
            }
        },
        payFxn: async () => {
            let params = {orderId};
            let {data: orderBackup} = await getSingleOrderFxn(params);
            console.log(orderBackup, 'orderBackup');
            if (orderBackup?.status == "Paid") {
                notification.warning({message: "Order already paid."});
            } else {
                if ((orderBackup?.discountPer ?? "" ?? 0) !== (discountper ?? "")) {
                    alert('Save order first to pay bill');
                    return
                }
                if ((orderBackup?.serviceTaxIncluded) !== serviceTaxIncluded) {
                    alert('Save order first to pay bill');
                    return
                }
                setSelectedPaymentInputs([]);
                setManualPaymentInputs([]);
                setIsPaymentModalOpen(true);
                setPaymentData({
                    // totalAmount: state.netAmount,
                    // finalAmount: state.netAmount,
                    totalAmount: Math.round(Number(state.netAmount || 0)),
                    finalAmount: Math.round(Number(state.netAmount || 0)),
                    orderNo: OldKots.orderNo,
                    orderId: orderId,
                    PaymentType: "",
                    customerPaid: 0,
                    cashAmount: 0,
                    upiAmount: 0,
                    cardAmount: 0,
                    returnToCustomer: 0,
                    tip: 0,
                    setteledAmount: 0,
                    cashDiscount: 0,
                });
            }

        }
    };

    const apiRequest1 = (params) => {
        return new Promise(async (resolve) => {
            const data = await FetchSpecialNotes({...params});
            setspecialNoteList(data.data);

            resolve(data);
        });
    };
    const loadMainMenus = async () => {
        try {
            const res = await axios.get(getMainMenuUrl(), getToken());

            if (res.data.success) {
                // setMainMenuOptions(res.data.data || []);
                const activeMenus = (res.data.data || []).filter((item) => item.status === "Active" && item.deleted !== true);
                setMainMenuOptions(activeMenus);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        if (!selectedMainMenu) {
            setSelectedMainCategory("");
            setProductList([]);
            setActiveIndex(0);
            return;
        }

        if (filteredMainCategories.length > 0) {
            const firstCategory = filteredMainCategories[0];
            const nextCategoryId = String(firstCategory._id || firstCategory.key || "");

            if (nextCategoryId && String(selectedMainCategory) !== nextCategoryId) {
                setSelectedMainCategory(nextCategoryId);
                setActiveIndex(0);
            }
        } else {
            setSelectedMainCategory("");
            setProductList([]);
            setActiveIndex(0);
        }
    }, [selectedMainMenu, dynamicMainCategories]);
    useEffect(() => {
        loadMainMenus();
    }, []);

    useEffect(() => {
        if (mainMenuOptions.length > 0 && !selectedMainMenu) {
            const defaultMenu = mainMenuOptions.find((item) => item.isDefault === true) || mainMenuOptions[0];

            setSelectedMainMenu(String(defaultMenu._id));
            // setSearchTerm(defaultMenu.mainMenuName || "");
            setSearchTerm("");
        }
    }, [mainMenuOptions]);

    const loadDynamicMainCategories = async () => {
        try {
            const res = await axios.get(getMainCategoryUrl(), getToken());

            if (res.data.success) {
                setDynamicMainCategories(res.data.data || []);
            }
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        if (discountCoupon) {
            events.getCouponDis();
        }
    }, [discountCoupon]);

    useEffect(() => {
        apiRequest1();
    }, []);

    let loadAllData = async () => {
        let {data} = await groupedProductFxn();

        let activeProducts = data.map((item) => {
            let categoriesWithActiveProducts = item.category.map((category) => {
                let activeProductsInCategory = category.product || [];
                return {...category, product: activeProductsInCategory};
            });
            return {...item, category: categoriesWithActiveProducts};
        });

        setAllData(activeProducts);

    };


    let loadProduct = async () => {
        let cloneAllData = _.cloneDeep(allData);

        let findDoc = _.find(cloneAllData, (item) => {
            return String(item?._id || "") === String(selectedMainCategory);
        });


        if (findDoc) {
            let sortedCategories = [...(findDoc.category || [])].sort((a, b) => (a.index || 0) - (b.index || 0));
            setProductList(sortedCategories);
            setActiveIndex(0);
            setRefreshKey(moment());
        } else {
            setProductList([]);
            setActiveIndex(0);
        }
    };

    useEffect(() => {
        if (selectedMainCategory && allData.length) {
            loadProduct();
        } else {
            setProductList([]);
        }
    }, [selectedMainCategory, allData]);

    useEffect(() => {
        loadAllData();
    }, []);
    useEffect(() => {
        loadDynamicMainCategories();
    }, []);

    useEffect(() => {
        setTimeout(() => {
            const currentURL = window.location.href;
            const tableNumber = currentURL.split("/").pop();
            const getTableName = (tableNo) => {
                const prefix = tableNo.split("-")[0].toLowerCase();
                return TABLE_MAP[prefix] || tableNo;
            };
            if (tableNumber) {
                setSaveTableName(getTableName(tableNumber));
            }
            setTableNo(tableNumber);
        }, 1000);
    }, [tableKey]);

    const getOldKotData = async (params) => {
        if (tableNo) {
            try {
                const data = await getOldKotFxn({...params, tableNo: tableNo});
                if (data) {

                    setOldKots(data.data.data);
                    const allSavedProducts = (data.data.data || []).flatMap((kot) => kot.products || []);
                    setSavedKotProducts(allSavedProducts);
                    setNoOfKots(data.data.total);
                    setOldKotTotalAmount(data.totalAmount);
                    setCurrentStatus(data.currentStatus);
                    events._updateState({
                        subTotal: data.subTotal ? Number(data.subTotal).toFixed(2) : "0.00",
                        totalAmount: data.totalAmount || 0,
                        discountAmount: data.discount ? Number(data.discount).toFixed(2) : "0.00",
                        cgstAmount: data.cgstAmount ? Number(data.cgstAmount).toFixed(2) : "0.00",
                        sgstAmount: data.sgstAmount ? Number(data.sgstAmount).toFixed(2) : "0.00",
                        serviceTaxAmount: data.serviceTaxAmount ? Number(data.serviceTaxAmount).toFixed(2) : "0.00",
                        tax: data.tax ? Number(data.tax).toFixed(2) : "0.00",
                        netAmount: data.netAmount ? Number(data.netAmount).toFixed(2) : "0.00",
                        nonGstDiscountAmount: data.nonGstDiscountAmount,
                        gstDiscountAmount: data.gstDiscountAmount,
                        amountAfterDiscount: data.amountAfterDiscount,
                    });
                    setSavedOrderSummary({
                        subTotal: data.subTotal ? Number(data.subTotal).toFixed(2) : "0.00",
                        totalAmount: data.totalAmount || 0,
                        discountAmount: data.discount ? Number(data.discount).toFixed(2) : "0.00",
                        cgstAmount: data.cgstAmount ? Number(data.cgstAmount).toFixed(2) : "0.00",
                        sgstAmount: data.sgstAmount ? Number(data.sgstAmount).toFixed(2) : "0.00",
                        serviceTaxAmount: data.serviceTaxAmount ? Number(data.serviceTaxAmount).toFixed(2) : "0.00",
                        tax: data.tax ? Number(data.tax).toFixed(2) : "0.00",
                        netAmount: data.netAmount ? Number(data.netAmount).toFixed(2) : "0.00",
                        nonGstDiscountAmount: data.nonGstDiscountAmount,
                        gstDiscountAmount: data.gstDiscountAmount,
                        amountAfterDiscount: data.amountAfterDiscount,
                    });
                    const totalProductsLength = data.data.data.reduce((acc, kot) => {
                        return acc + kot.products.length;
                    }, 0);
                    // setOrderId(data.data.data[0].orderId);
                    setOrderId(data.data.data?.[0]?.orderId || "");
                    setTotalProductsLength(totalProductsLength);
                    if (data.discountPer) {
                        setdiscountper(data.discountPer);
                    }
                    if (data.couponCode) {
                        setCouponCode(data.couponCode);
                        setCouponId(data.couponId);
                    }
                    if (data.customerName) {
                        setCustomerMobile(data.customerMobile);
                        setCustomerName(data.customerName);
                        setCustomerEmail(data.customerEmail || "");
                        setCustomerGst(data.customerGst || "");
                    }
                    if (data.paxNumber) {
                        setPaxLength(data.paxNumber);
                    }
                    setServiceTaxIncluded(data.serviceTaxIncluded);
                    setIsComplementaryBill(data.isComplementaryBill === true);
                    setComplementaryReason(data.complementaryReason || "");
                }
            } catch (error) {
                // console.error("Error fetching data:", error);
            }
        }
    }
    useEffect(() => {
        if (orderId) {
            setShowComplementaryButton(true);
        } else {
            setShowComplementaryButton(false);
        }
    }, [orderId]);
    const getAllBillProducts = () => {
        const oldProducts = (savedKotProducts || []).map((item) => ({
            ...item,
            productId: item?.productId?._id || item?.productId || item?._id,
            categoryId: item?.categoryId || item?.productId?.categoryId || {},
            price: parseFloat(item?.price || item?.amount || 0),
            quantity: Number(item?.quantity || 1),
            totalAmount: parseFloat(item?.totalAmount || (parseFloat(item?.price || item?.amount || 0) * Number(item?.quantity || 1))),
        }));

        const newProducts = (selectedProducts || []).map((item) => ({
            ...item,
            productId: item?.productId || item?._id,
            categoryId: item?.categoryId || {},
            price: parseFloat(item?.price || 0),
            quantity: Number(item?.quantity || 1),
            totalAmount: parseFloat(item?.totalAmount || (parseFloat(item?.price || 0) * Number(item?.quantity || 1))),
        }));

        return [...oldProducts, ...newProducts];
    };
    useEffect(() => {
        if (tableNo) {
            getOldKotData();
        }
    }, [tableNo]);

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    useEffect(() => {
        if (singleOrderData && singleOrderData._id) {
            handlePrint();
        }
    }, [singleOrderData]);


    useEffect(() => {

    }, [])

    let loadOrderData = async (orderId) => {
        let params = {orderId};
        let resp = await dispatch(getPrintProductsFxn(params));
        setSingleOrderData(resp);
    };


    let handleAddOrder = async (selectedProducts, kotSubmitType) => {
        if (loading) return;
        setLoading(true);
        let params = {orderId};
        let {data: orderBackup} = await getSingleOrderFxn(params);
        if (orderBackup?.status == "Paid") {
            notification.warning({message: "Order already paid."});
            return
        }
        if (selectedProducts.length == 0) {
            notification.warning({message: "Please Add Some Food Item To Add Kot"});
            setLoading(false);
            return;

        }


        formData.products = selectedProducts;
        // formData.products.forEach((product) => {
        //   product.specialNote = selectedNote;
        // });
        formData.tableNo = tableNo;

        const {
            totalAmount, discountAmount, cgstAmount, sgstAmount, serviceTaxAmount, tax, netAmount, subTotal,

            nonGstDiscountAmount,
            gstDiscountAmount,
            amountAfterDiscount
        } = state;
        formData.subTotal = subTotal;
        formData.totalAmount = totalAmount;
        formData.discount = discountAmount;
        formData.discountPer = discountper;
        if (discountType) {
            formData.discountType = discountType;
        }
        formData.cgstAmount = cgstAmount;
        formData.sgstAmount = sgstAmount;
        formData.serviceTaxAmount = serviceTaxAmount;
        formData.serviceTaxIncluded = serviceTaxIncluded;
        formData.tax = tax;
        formData.netAmount = netAmount;
        formData.kotSubmitType = kotSubmitType;
        formData.guest = guest;
        formData.customerName = customerName;
        formData.paxNumber = paxLength;
        formData.tableName = saveTableName;
        formData.nonGstDiscountAmount = nonGstDiscountAmount;
        formData.gstDiscountAmount = gstDiscountAmount
        formData.amountAfterDiscount = amountAfterDiscount;
        formData.totalTaxable = state.totalTaxable;


        let x = await dispatch(addOrderFxn(formData));
        if (x && x.success == true) {
            if (kotSubmitType === "kotAndPrint") {
                const printSnapshot = {
                    products: selectedProducts,
                    tableNo: formData.tableNo,
                    subTotal: formData.subTotal,
                    totalAmount: formData.totalAmount,
                    discount: formData.discount,
                    cgstAmount: formData.cgstAmount,
                    sgstAmount: formData.sgstAmount,
                    serviceTaxAmount: formData.serviceTaxAmount,
                    serviceTaxIncluded: formData.serviceTaxIncluded,
                    tax: formData.tax,
                    netAmount: formData.netAmount,
                    customerName: formData.customerName,
                    paxNumber: formData.paxNumber,
                    tableName: formData.tableName,
                };

                setKotPrintData(printSnapshot);
            }

            setSelectedProducts([]);
            getOldKotData();
            setLoading(false);
        }
        else {
            // setLoading(false);
        }
        // if (x && x.success == true) {
        //     setSelectedProducts([]);
        // }

    };


    let handleEditkot = async (editKotProducts, kotSubmitType) => {
        editdata.products = editKotProducts;
        editdata.tableNo = tableNo;
        editdata.kotId = kotId;
        editdata.kotSubmitType = kotSubmitType;
        editdata.serviceTaxIncluded = serviceTaxIncluded;
        editdata.discountPer = discountper;
        let x = await dispatch(editKotFxn(editdata));
        if (x && x.success == true) {
            setEditKotModal(false);
        }
    };
    let handleSaveOrder = async (selectedProducts, orderSubmitType) => {
        if (loading) return;

        let params = {orderId};
        let {data: orderBackup} = await getSingleOrderFxn(params);
        if (orderBackup?.status == "Paid") {
            notification.warning({message: "Order already paid."});
            return
        }
        formData.products = selectedProducts;
        if (selectedProducts.length !== 0) {
            notification.warning({message: "Cannot Save Order, Some Products Are pending!"});
            return;
        }
        formData.tableNo = tableNo;
        const {
            totalAmount,
            discountAmount,
            cgstAmount,
            sgstAmount,
            serviceTaxAmount,
            tax,
            netAmount,
            subTotal,
            taxableAmount,
            nonTaxableAmount,
            nonGstDiscountAmount,
            gstDiscountAmount,
            amountAfterDiscount
        } = state;
        formData.subTotal = subTotal;
        formData.totalAmount = totalAmount;
        formData.discount = discountAmount;
        formData.discountPer = discountper;
        formData.taxableAmount = taxableAmount;
        formData.nonTaxableAmount = nonTaxableAmount;
        formData.cgstAmount = cgstAmount;
        formData.sgstAmount = sgstAmount;
        formData.serviceTaxAmount = serviceTaxAmount;
        formData.tax = tax;
        formData.netAmount = netAmount;
        formData.orderId = orderId;
        formData.orderSubmitType = orderSubmitType;
        formData.serviceTaxIncluded = serviceTaxIncluded;
        formData.customerName = customerName;
        formData.customerMobile = customerMobile;
        formData.customerEmail = customerEmail;
        formData.customerGst = customerGst;
        formData.paxNumber = paxLength;
        formData.tableName = saveTableName;
        formData.isComplementaryBill = isComplementaryBill;
        formData.complementaryReason = complementaryReason;
        formData.nonGstDiscountAmount = nonGstDiscountAmount;
        formData.gstDiscountAmount = gstDiscountAmount
        formData.amountAfterDiscount = amountAfterDiscount;
        formData.totalTaxable = state.totalTaxable;

        if (couponId && couponCode) {
            formData.couponId = couponId;
            formData.couponCode = couponCode;
        }
        if (discountType) {
            formData.discountType = discountType;
        }

        setLoading(true)
        let x = await dispatch(saveOrderFxn(formData));
        if (x && x.success == true) {
            setShowComplementaryButton(false);
            setKotPrintData(null);
            setTimeout(() => {
                loadOrderData(orderId);
                setTimeout(() => {
                    getOldKotData();
                }, 1500);
            }, 1000)
            setLoading(false)
        } else {
            setLoading(false)
        }
    };

    let handleSave = async (selectedProducts, orderSubmitType) => {
        let params = {orderId};
        let {data: orderBackup} = await getSingleOrderFxn(params);
        if (orderBackup?.status == "Paid") {
            notification.warning({message: "Order already paid."});
            return
        }
        if (selectedProducts.length !== 0) {
            notification.warning({
                message: "Cannot Save Order, Some Items Are pending!",
            });
            return;
        }
        formData.products = selectedProducts;
        formData.tableNo = tableNo;
        const {
            totalAmount, discountAmount, cgstAmount, sgstAmount, serviceTaxAmount, tax, netAmount, subTotal,
            nonGstDiscountAmount,
            gstDiscountAmount,
            amountAfterDiscount
        } = state;
        formData.subTotal = subTotal;
        formData.totalAmount = totalAmount;
        formData.discount = discountAmount;
        formData.discountPer = discountper;
        formData.cgstAmount = cgstAmount;
        formData.sgstAmount = sgstAmount;
        formData.serviceTaxAmount = serviceTaxAmount;
        formData.tax = tax;
        formData.netAmount = netAmount;
        formData.orderId = orderId;
        formData.orderSubmitType = orderSubmitType;
        formData.serviceTaxIncluded = serviceTaxIncluded;
        formData.customerName = customerName;
        formData.customerMobile = customerMobile;
        formData.customerEmail = customerEmail;
        formData.customerGst = customerGst;
        formData.paxNumber = paxLength;
        formData.tableName = saveTableName;
        if (couponId && couponCode) {
            formData.couponId = couponId;
            formData.couponCode = couponCode;
        }
        formData.nonGstDiscountAmount = nonGstDiscountAmount;
        formData.gstDiscountAmount = gstDiscountAmount
        formData.amountAfterDiscount = amountAfterDiscount;
        formData.totalTaxable = state.totalTaxable;
        if (discountType) {
            formData.discountType = discountType;
        }
        let x = await dispatch(saveOrderFxn(formData));
        if (x && x.success == true) {
            // loadOrderData(orderId);
            setTimeout(() => {
                getOldKotData();
            }, 1500);
        }
    };

    const resp = useSelector((state) => {
        let {isRefreshKot, kotData, isKotSaved, isOrderTransferred, newTableNo} = state.global;
        if (isRefreshKot) {
            events.refreshKot(kotData);
            getOldKotData();
            dispatch({type: "REFRESH_KOT", kotData: {}, isRefreshKot: false});
        }
        if (isKotSaved) {
            getOldKotData();
            dispatch({type: "KOT_SAVED", kotIds: [], isKotSaved: false});
        }
        if (isOrderTransferred) {
            if (tableNo !== newTableNo) {
                navigate(`/pos/${newTableNo}`);
            }
            dispatch({
                type: "TRANSFER_ORDER", orderId: "", isOrderTransferred: false, newTableNo: "",
            });
        }
    });


    // new code
    const handleSearch = () => {
        if (!searchTerm.trim()) {
            notification.warning({message: "Please Enter Product Name"});
            return;
        }

        handleProductSearch();
    };
    const getAllSearchableProducts = () => {
        return allData.flatMap((group) => (group.category || []).flatMap((subCategory) => (subCategory.product || []).filter((product) => product.productStatus === "Active")));
    };
    const handleProductSearch = () => {
        const value = (searchTerm || "").trim();

        if (!value) {
            notification.warning({message: "Please Enter Product Name"});
            return;
        }

        const searchableProducts = getAllSearchableProducts();

        const filtered = searchableProducts.filter((product) => product?.name?.toLowerCase().includes(value.toLowerCase()));

        setFilteredProducts(filtered);
    };


    const handleAddNote = () => {
        if (notes !== "" || manualNote !== "") {
            const updatedProducts = selectedProducts.map((product) => {
                if (product.productId === productIds && product.variant == varient) {
                    return {...product, specialNote: manualNote !== "" ? manualNote : notes};
                }
                return product;
            });

            setSelectedProducts(updatedProducts);
            setIsSpecialNoteModalOpen(false);
            setNotes("");
            setmanualNote("");
        } else {
            // Show message if note is empty
            notification.warning({message: "Select Special Note"});
        }
    };

    const handleReset = () => {
        setFilteredProducts([]);
        setSearchSuggestions([]);
        setShowSuggestions(false);
        setSearchTerm("");
    };

    const closePaxDrawer = () => {
        setChoosePaxDrawer({
            visible: false,
        });
    };
    const openPaxDrawer = () => {
        setChoosePaxDrawer({
            visible: true,
        });
    };


    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleSearch();
        }
    };

    const handleAutoSelect = (item) => {
        setSearchTerm(item.mainMenuName || "");
        setSelectedMainMenu(String(item._id));
        setSelectedMainCategory("");
        setProductList([]);
        setActiveIndex(0);
        setShowSuggestions(false);
        setFilteredProducts([]);
    };

    // new code
    const handleSearchInputChange = (e) => {
        const val = e.target.value;
        setSearchTerm(val);

        if (!val.trim()) {
            setFilteredProducts([]);
            return;
        }

        const searchableProducts = getAllSearchableProducts();

        const filtered = searchableProducts.filter((product) => product?.name?.toLowerCase().includes(val.toLowerCase()));

        setFilteredProducts(filtered);
    };
    // new code


    let buttonComponent = (<div className="d-flex">

        <button
            className="btn btn-success ms-1"
            disabled={loading}
            onClick={() => {
                handleAddOrder(selectedProducts, "kotAndPrint");
            }}>
            kot & print
        </button>
        {userType != "captain" && (<button
            className="btn btn-success ms-1"
            disabled={loading}
            onClick={() => {
                handleSaveOrder(selectedProducts, "saveAndPrint");
            }}
        >
            Save Bill & Print
        </button>)}
    </div>);
    let finalbutton = (<div className="d-flex">
        {userType != "captain" && (<>
            <button
                className="btn btn-success ms-1"
                onClick={() => {
                    handleSave(selectedProducts);
                }}
            >
                Save
            </button>
            <button
                className="btn btn-success ms-1"
                onClick={() => {
                    // handleSaveOrder(selectedProducts);
                    handleSaveOrder(selectedProducts, "saveAndPrint");
                }}
            >
                Save Bill & Print
            </button>
            <button
                onClick={events.payFxn}
                className="btn btn-success ms-1">
                Pay
            </button>
        </>)}
    </div>);

    // const handleSaveButtonClick = () => {
    //     setIsDiscountModalOpen(false);
    //     if (discountper !== "" && discountper <= 10) {
    //         setdiscountper(discountper);
    //     } else if (discountper > 10) {
    //         setdiscountper(0);
    //         notification.warning({
    //             message: "Discount Cannot Be Greater Than 10%",
    //         });
    //     } else {
    //         setdiscountper("");
    //     }
    // };
    const handleSaveButtonClick = () => {
        const oldDiscount = Number(savedOrderSummary?.discountPer || 0);
        const newDiscount = Number(discountper || 0);
        if (newDiscount > 10) {
            setdiscountper(0);
            setIsDiscountModalOpen(false);
            notification.warning({
                message: "Discount Cannot Be Greater Than 10%",
            });
            return;
        }
        // if (currentStatus === "Done" && newDiscount !== oldDiscount) {
        //     notification.warning({
        //         message: "Bill already printed! Please click 'Save Bill & Print' to update the final receipt with this new discount.",
        //     });
        // }
        if (currentStatus === "Done" && newDiscount !== oldDiscount) {
            alert("Bill already printed! Please click 'Save Bill & Print' to update the final receipt with this new discount.");
        }
        setIsDiscountModalOpen(false);
        if (discountper !== "" && newDiscount <= 10) {
            setdiscountper(discountper);
        } else {
            setdiscountper("");
        }
    };
    const location = useLocation();
    const path = location.pathname;
    const segments = path.split("/");
    const lastSegment = segments[segments.length - 1];

    useEffect(() => {
        if (lastSegment.startsWith("g-")) {
            setGuest(true);
        } else {
            setGuest(false);
        }
    }, [lastSegment]);

    let [tableList, setTableList] = useState([]);
    let [tableNumbers, setTableNumbers] = useState([]);

    let loadTables = async () => {
        let {data} = await tableListFxn();
        data = data.filter((item) => item.name !== "Guest" && item.name !== "HOD" && item.name !== "MD",);
        setTableList(data);
    };

    useEffect(() => {
        loadTables();
    }, []);

    let loadTableNumbers = async (tableName) => {
        let {data} = await tableListFxn();
        let filtered = {};
        if (tableName) {
            let filteredArray = data.filter((item) => item.name === tableName);
            if (filteredArray.length > 0) {
                filtered = filteredArray[0];
            }
        }
        if (filtered.tables) {
            let allTableNumber = filtered.tables;
            let emptyTables = allTableNumber.filter((item) => !item.orderNo);
            setTableNumbers(emptyTables);
        }
    };
    useEffect(() => {
        if (tableName) {
            loadTableNumbers(tableName);
        }
    }, [tableName]);

    let [transferData, setTransferData] = useState({});

    let transferTable = async (orderId, tableNumber) => {
        if (!orderId) {
            notification.warning({
                message: "Order Not Found",
            });
            return;
        }
        transferData.orderId = orderId;
        transferData.tableNo = tableNumber;
        transferData.transferDetails = `Transfered to ${tableNumber}`;
        let x = await dispatch(TransferTableFxn(transferData));
        if (x && x.success == true) {
            setisTransferTableModalOpen(false);
            setTableKey(new Date().toString());
            navigate(`/pos/${tableNumber}`);
        }
    };

    const [modalWidth, setModalWidth] = useState("95%");
    let transferKot = async () => {
        if (!transferKotData?.kotId) {
            notification.warning({
                message: "KOT Not Found",
            });
            return;
        }

        if (!transferKotTableNumber) {
            notification.warning({
                message: "Please Select Table Number",
            });
            return;
        }

        const payload = {
            kotId: transferKotData.kotId,
            fromOrderId: transferKotData.orderId,
            toTableNo: transferKotTableNumber,
            transferDetails: `Transfered to ${transferKotTableNumber}`,
        };

        let x = await dispatch(TransferKotFxn(payload));

        if (x && x.success === true) {
            const newTableNo = transferKotTableNumber;
            setIsTransferKotModalOpen(false);
            setTransferKotData({
                orderId: "", kotId: "",
            });
            setTransferKotTableName("");
            setTransferKotTableNumber("");
            setTransferKotTableNumbers([]);
            // getOldKotData();
            // navigate(`/pos/${newTableNo}`);
            setTimeout(() => {
                navigate(`/pos/${newTableNo}`);
                setTableKey(new Date().toString());
            }, 500);
        }
    };
    let transferKotItem = async () => {
        const qty = Number(moveItemQty || 0);

        if (!orderId) {
            notification.warning({message: "Order not found."});
            return;
        }

        if (!moveItemData || !moveItemData.name) {
            notification.warning({message: "Item not found."});
            return;
        }

        if (!qty || qty <= 0) {
            notification.warning({message: "Please enter valid quantity."});
            return;
        }

        if (qty > Number(moveItemData.quantity || 0)) {
            notification.warning({message: "Move quantity cannot be greater than available quantity."});
            return;
        }

        if (!moveItemTableNumber) {
            notification.warning({message: "Please select table."});
            return;
        }

        const payload = {
            fromOrderId: orderId,
            fromTableNo: tableNo,
            toTableNo: moveItemTableNumber,
            productId: moveItemData.productId,
            variant: moveItemData.variant || "",
            price: moveItemData.price,
            quantity: qty,
            transferDetails: `Moved ${moveItemData.name} to ${moveItemTableNumber}`,
        };

        let x = await dispatch(TransferKotItemFxn(payload));

        if (x && x.success === true) {
            const newTableNo = moveItemTableNumber;

            setIsMoveItemModalOpen(false);
            setIsAllKotItemsModalOpen(false);

            setMoveItemData({});
            setMoveItemQty(1);
            setMoveItemTableName("");
            setMoveItemTableNumber("");
            setMoveItemTableNumbers([]);

            setTimeout(() => {
                navigate(`/pos/${newTableNo}`);
                setTableKey(new Date().toString());
            }, 500);
        }
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 800) {
                setModalWidth("95%");
            } else {
                setModalWidth("55%");
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);


    const getMainCategoryImage = (mainCategoryId) => {
        if (!dynamicMainCategories || !dynamicMainCategories.length) return "";

        const matchedMainCategory = dynamicMainCategories.find((item) => {
            return String(item._id) === String(mainCategoryId);
        });

        return matchedMainCategory?.mainCategoryFile?.path || "";
    };

    const dynamicNames = dynamicMainCategories.map((item) => item.mainCategoryName?.toLowerCase(),);

    const filteredStatic = category.filter((item) => !dynamicNames.includes(item.key?.toLowerCase()),);

    const mergedMainCategories = [...dynamicMainCategories.map((item) => ({
        ...item, source: "dynamic", key: item._id, name: item.mainCategoryName, uniqueKey: `dynamic-${item._id}`,
    })),];

    const filteredMainCategories = mergedMainCategories.filter((item) => {
        if (!selectedMainMenu) return false;

        const itemMainMenuId = String(item?.mainMenuId?._id || item?.mainMenuId || "");
        return itemMainMenuId === String(selectedMainMenu);
    });

    const handleMainMenuChange = (e) => {
        const selectedValue = String(e.target.value);

        setSelectedMainMenu(selectedValue);
        setActiveIndex(0);
        handleReset();

        const nextFilteredCategories = mergedMainCategories.filter((item) => {
            const itemMainMenuId = String(item?.mainMenuId?._id || item?.mainMenuId || "");
            return itemMainMenuId === selectedValue;
        });

        const firstMatchingCategory = nextFilteredCategories[0];

        if (firstMatchingCategory) {
            setSelectedMainCategory(String(firstMatchingCategory._id || firstMatchingCategory.key));
        } else {
            setSelectedMainCategory("");
            setProductList([]);
        }
    };
    const getMergedKotItems = () => {
        const merged = {};

        (OldKots || []).forEach((kot) => {
            (kot.products || []).forEach((item) => {
                const productId = item?.productId?._id || item?.productId || ""; // ✅ ADD THIS

                const name = item?.productId?.name || item?.name || "";
                const variant = item?.variant || "";
                const price = Number(item.price || item.amount || 0);

                const vegNonVeg =
                    item?.productId?.vegNonVeg ||
                    item?.vegNonVeg ||
                    "";
                const key = `${productId}_${variant}_${price}`;

                if (!merged[key]) {
                    merged[key] = {
                        productId, // ✅ ADD THIS
                        name,
                        variant,
                        price,
                        vegNonVeg,
                        quantity: 0,
                    };
                }

                merged[key].quantity += Number(item.quantity || 1);
            });
        });

        return Object.values(merged);
    };
    const handleMoveItemClick = (item) => {
        if (!canShowMoveItem) {
            notification.warning({message: "Move not allowed after bill settlement"});
            return;
        }
        const availableQty = Number(item.quantity || 0);

        setMoveItemData(item);

        if (availableQty > 1) {
            setMoveItemQty("");
            setIsMoveItemModalOpen(true);
        } else {
            setMoveItemQty(1);
            setIsMoveItemModalOpen(true);
        }
    };
    return (<>
        <PageHeader>
            <div key={tableKey}>
                {/* <div className="row d-flex"> */}
                <div className="row d-flex gx-0">
                    {/* <div className="col-xl-9 col-lg-8 col-md-7 col-sm-7 tabs_wrapper"> */}
                    <div className="col-xl-9 col-lg-8 col-md-7 col-sm-7 tabs_wrapper pe-0 ps-0">
                        <div className="page-header figma-header">
                            <div className="figma-page-title">
                                <h4>Menu Items</h4>
                                <h6>Manage your purchases</h6>
                            </div>
                            {/*<div className="figma-menu-search-wrap">*/}
                            <div className="figma-menu-search-wrap pos-search-row">
                                <div className="figma-menu-search inside-search-wrapper">
                                    <div>
                                        <i className="fa fa-search search-left-icon"></i>

                                        <input
                                            type="text"
                                            placeholder="Search Products..."
                                            value={searchTerm}
                                            onChange={handleSearchInputChange}
                                            onKeyPress={handleKeyPress}
                                        />

                                    </div>
                                    <div>
                                        <div className="inside-input-dropdown">
                                            <select
                                                className="form-control"
                                                value={selectedMainMenu}
                                                onChange={handleMainMenuChange}
                                            >
                                                {mainMenuOptions.map((item) => (
                                                    <option key={item._id} value={item._id}>
                                                        {item.mainMenuName}
                                                    </option>))}
                                            </select>
                                        </div>

                                        <button
                                            className="figma-search-btn"
                                            onClick={handleSearch}
                                            type="button"
                                        >
                                            <i className="fa fa-search"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>

                        {!isSearchingProducts && selectedMainMenu && filteredMainCategories.length > 0 && (// new code
                            <div className="figma-main-category-wrap">
                                {filteredMainCategories.map((item) => {
                                    const itemKey = String(item._id || item.key || "");
                                    const itemName = item.name || item.mainCategoryName || "";

                                    return (<div
                                        key={item.uniqueKey}
                                        className={`figma-main-category-pill ${String(selectedMainCategory) === itemKey ? "active" : ""}`}
                                        onClick={() => {
                                            setSelectedMainCategory(itemKey);
                                            setActiveIndex(0);
                                            handleReset();
                                        }}
                                    >
                                        {getMainCategoryImage(itemKey) ? (
                                            <div className="figma-main-category-icon">
                                                <img
                                                    src={`${apiUrl}${getMainCategoryImage(itemKey)}`}
                                                    alt={itemName}
                                                    className="figma-main-category-icon-img"
                                                />
                                            </div>) : null}

                                        <span className="figma-main-category-text">{itemName}</span>
                                    </div>);
                                })}
                            </div>)}
                        {isSearchingProducts && filteredProducts.length > 0 && (<div className="figma-product-grid">
                            {filteredProducts
                                .sort((a, b) => a.name.localeCompare(b.name))
                                .map((eachPro) => {
                                    return (<div
                                        className={`figma-product-card ${clickedProId == eachPro._id ? "clickedPro" : ""}`}
                                        key={eachPro._id}
                                        onClick={() => {
                                            seClickedProId(eachPro._id);
                                            if (currentStatus == "Done") {
                                                notification.warning({
                                                    message: "Order is Already Saved Cannot Add Kot",
                                                });
                                                return;
                                            }

                                            if (eachPro.variants.length == 0 || eachPro.variants.length == 1) {
                                                events.addProduct({
                                                    ...eachPro, productId: eachPro._id,
                                                });
                                            } else {
                                                setVariantData({
                                                    ...eachPro,
                                                });
                                                setIsModalOpen(true);
                                            }
                                        }}
                                    >
                                        <div
                                            className={`figma-food-badge ${String(eachPro.vegNonVeg || eachPro.variant || "").toLowerCase() === "egg" ? "egg" : ["non veg", "non-veg", "chicken", "mutton", "fish", "prawns"].includes(String(eachPro.vegNonVeg || eachPro.variant || "").toLowerCase()) ? "nonveg" : "veg"}`}
                                        >
                                            <span className="figma-food-badge-dot"></span>
                                        </div>

                                        <div className="figma-product-body">
                                            <h4>{eachPro.name}</h4>
                                            <p>{eachPro.description || ""}</p>
                                        </div>

                                        <div className="figma-product-bottom">
                                            <h5>₹{eachPro.price}</h5>
                                            <button
                                                className="figma-add-btn"
                                                type="button"
                                            >
                                                + Add
                                            </button>
                                        </div>
                                    </div>);
                                })}
                        </div>)}
                        {/*{selectedMainCategory && productList && productList.length > 0 && (*/}

                        {!isSearchingProducts && selectedMainCategory && productList && productList.length > 0 && (
                            <div className="figma-subcategory-row">
                                <ul className={"tabs dd"} key={refreshKey}>
                                    <OwlCarousel
                                        lazyContent={true}
                                        key={activeIndex}
                                        className="owl-carousel owl-theme owl-product border-0 pt-2"
                                        {...options}
                                    >
                                        {productList.map((item, index) => {
                                            return (item.deleted !== true && (<li
                                                className={index == activeIndex ? "active" : ""}
                                                id={item.name}
                                                key={item._id || item.productId || index}
                                                onClick={() => {
                                                    setActiveIndex(index);
                                                    handleReset();
                                                }}
                                            >
                                                <div className="figma-subcategory-tab">
                                                    <span>{item.name ? item.name : ""}</span>
                                                </div>
                                            </li>));
                                        })}
                                    </OwlCarousel>
                                </ul>
                            </div>)}

                        {/*{productList && productList.length ? (*/}

                        {!isSearchingProducts && productList && productList.length ? (

                            <div className="tabs_container" key={activeIndex}>
                                {productList.map((item, index) => {
                                    return (

                                        <div
                                            className={`tab_content ${activeIndex == index ? "active" : ""}`}
                                            data-tab={item.name}
                                            key={item._id || item.productId || index}
                                        >

                                            <div className="figma-product-grid">
                                                {item && item.product ? item.product
                                                    .sort((a, b) => a.name.localeCompare(b.name))
                                                    .map((eachPro) => {
                                                        return (<div
                                                            className={`figma-product-card ${clickedProId == eachPro._id ? "clickedPro" : ""}`}
                                                            key={eachPro._id}
                                                            onClick={() => {
                                                                seClickedProId(eachPro._id);
                                                                if (currentStatus == "Done") {
                                                                    notification.warning({
                                                                        message: "Order is Already Saved Cannot Add Kot",
                                                                    });
                                                                    return;
                                                                }

                                                                if (eachPro.variants.length == 0 || eachPro.variants.length == 1) {
                                                                    events.addProduct({
                                                                        ...eachPro, productId: eachPro._id,
                                                                    });
                                                                } else {
                                                                    setVariantData({
                                                                        ...eachPro,
                                                                    });
                                                                    setIsModalOpen(true);
                                                                }
                                                            }}
                                                        >

                                                            <div
                                                                className={`figma-food-badge ${String(eachPro.vegNonVeg || eachPro.variant || "").toLowerCase() === "egg" ? "egg" : ["non veg", "non-veg", "chicken", "mutton", "fish", "prawns"].includes(String(eachPro.vegNonVeg || eachPro.variant || "").toLowerCase()) ? "nonveg" : "veg"}`}
                                                            >
                                                                            <span
                                                                                className="figma-food-badge-dot"></span>
                                                            </div>

                                                            <div className="figma-product-body">
                                                                <h4>{eachPro.name}</h4>
                                                                <p>
                                                                    {eachPro.description || ""}
                                                                </p>
                                                            </div>

                                                            <div className="figma-product-bottom">
                                                                <h5>₹{eachPro.price}</h5>
                                                                <button
                                                                    className="figma-add-btn"
                                                                    type="button"
                                                                >
                                                                    + Add
                                                                </button>
                                                            </div>
                                                        </div>);
                                                    }) : null}

                                            </div>
                                        </div>);
                                })}
                            </div>) : null}

                        {/* MODAL For Choose Variant */}

                        {isModalOpen && (<Modal
                            visible={isModalOpen}
                            onClose={() => {
                                setIsModalOpen(false);
                                setBgIndex();
                                seClickedProId("");
                            }}
                            title={variantData.name}
                            width={modalWidth}
                        >
                            <Card>
                                <div className={"rest-table-box"}>
                                    <div className={"tab-header"}>
                                        <span>Variants</span>
                                    </div>
                                    <div className={"table-list"}>
                                        {variantData?.variants?.map((item, index) => (<div
                                            key={index}
                                            className={`tab-box mb-0`}
                                            style={{
                                                background: bgIndex === index ? "#FF9F43" : "",
                                                color: bgIndex === index ? "white" : "",
                                            }}
                                            onClick={() => {
                                                setBgIndex(index);
                                                let obj = {...variantData};
                                                obj.price = item.price;
                                                obj.variant = item.name;
                                                setVariantData(obj);
                                                // setSelectedProducts(...selectedProducts,obj)
                                            }}
                                        >
                                            <p className="mb-0">{item.name}</p>
                                            <p className="mb-0">Rs. {item.price}</p>
                                        </div>))}
                                    </div>
                                </div>
                                <div
                                    className="d-grid gap-2 d-md-flex justify-content-md-end variantButton d-flex">
                                    <div>
                                        <button
                                            className="btn btn-danger ms-2 "
                                            onClick={() => {
                                                seClickedProId("");

                                                setBgIndex();
                                                setIsModalOpen(false);
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                    <div>
                                        <button
                                            className="btn btn-success "
                                            onClick={() => {
                                                if (!variantData.variant) {
                                                    notification.warning({
                                                        message: "Please Choose Variant",
                                                    });
                                                    return;
                                                } else {
                                                    setBgIndex();
                                                    setIsModalOpen(false);
                                                    delete variantData.variants;
                                                    events.addProduct(variantData);
                                                }
                                            }}
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </Card>
                        </Modal>)}
                    </div>
                    {/* <div className="col-xl-3 col-lg-4 col-md-5 col-sm-5 "> */}
                    <div className="col-xl-3 col-lg-4 col-md-5 col-sm-5 ps-0">
                        <div className="order-list mb-2">
                            <div className="orderid">
                                <h4 className={'lineHeight1'}>Order</h4>
                            </div>


                            <div className="action-group">
                                {orderId && !guest ? (<>
                                    <UserRights
                                        user={currentUser}
                                        userTypes={['fbManager', 'gm', 'cashier', 'admin', 'md']}
                                    >
                                        <a
                                            className={"btn btn-adds btn-xs"}
                                            onClick={() => setisTransferTableModalOpen(true)}
                                        >
                                            Transfer Table
                                        </a>
                                    </UserRights>
                                    <UserRights
                                        user={currentUser}
                                        userTypes={['fbManager', 'gm', 'md', 'admin', 'cashier']}>
                                        {canShowTransferMerge && (<a
                                            className={"btn btn-adds btn-xs"}
                                            onClick={() => {
                                                setSelectedMergeTable("");
                                                loadRunningTables();
                                                setIsMergeTableModalOpen(true);
                                            }}
                                        >
                                            Merge Table
                                        </a>)}
                                    </UserRights>
                                </>) : null}
                                <a className={"btn btn-adds btn-xs"}
                                   onClick={() => events.showCustomerModal()}>
                                    <i className="fa fa-plus me-2"/> Add Customer
                                </a>
                            </div>
                        </div>
                        <div className="card card-order mt-2 mb-0 ">
                            <div className="totalitem pt-3 spaceRemove">
                                <h4
                                    className="btn btn-link"
                                    onClick={() => {
                                        setIsOldkotModalOpen(true);
                                    }}
                                >
                                    <smal style={{fontSize: 11, color: "black"}}>
                                        Order Total Kots : {noOfKots}
                                        {" | "}
                                    </smal>
                                    Items : {selectedProducts.length + totalProductsLength}
                                    &nbsp;
                                </h4>

                                <h4>
                                    <strong className="text-uppercase">{tableNo}</strong>
                                </h4>
                            </div>
                            <div className={"totalitem spaceRemove"}>
                                {customerName && (<>
                                    <h4>
                                        <strong className="text-uppercase">
                                            {customerName}&nbsp;({customerMobile})
                                        </strong>
                                        <i
                                            className="clearButton"
                                            onClick={() => {
                                                setCustomerMobile("");
                                                setCustomerName("");
                                                setCouponCode("");
                                                setdiscountper("");
                                                setDisCouponCode("");
                                                setDiscountCoupon("");
                                            }}>
                                            ❌
                                        </i>
                                    </h4>
                                </>)}

                                <UserRights
                                    user={currentUser}
                                    userTypes={["cashier", "captain", "admin", "fbManager"]}>
                                    <h4 onClick={openPaxDrawer} className="btn btn-link">
                                        <strong className="text-uppercase">
                                            Pax - {paxLength}
                                        </strong>
                                    </h4>
                                </UserRights>

                                <UserRights
                                    user={currentUser}
                                    userTypes={['fbManager', 'gm', 'cashier', 'admin', 'md', 'captain']}>
                                    {/*{showComplementaryButton && canShowTransferMerge && (*/}
                                    {showComplementaryButton &&
                                        canShowTransferMerge &&
                                        currentUser?.userType !== "captain" && (
                                            <button
                                                type="button"
                                                className={`btn btn-xs ms-2 ${isComplementaryBill ? "btn-warning" : "btn-outline-warning"}`}
                                                onClick={() => {
                                                    if (isComplementaryBill) {
                                                        setIsComplementaryBill(false);
                                                        setComplementaryReason("");
                                                    } else {
                                                        setIsComplementaryReasonModalOpen(true);
                                                    }
                                                }}
                                            >
                                                {isComplementaryBill ? "Complimentary Applied" : "Make Complimentary"}
                                            </button>)}
                                    <button
                                        type="button"
                                        className="btn btn-outline-success btn-xs ms-2"
                                        style={{
                                            whiteSpace: "nowrap",
                                            padding: "2px 8px",
                                            height: "26px",
                                            fontSize: "11px",
                                            lineHeight: "18px",
                                            minWidth: "auto"
                                        }}
                                        onClick={() => setIsAllKotItemsModalOpen(true)}
                                    >
                                        Item Summary
                                    </button>
                                </UserRights>
                            </div>

                            <div className="dark-background">
                                <h7>New kot</h7>
                            </div>
                            <div className="card-body pt-0 height">
                                <div>
                                    {selectedProducts && selectedProducts.length ? selectedProducts.map((item) => {
                                        return (<ul
                                            className="product-lists mb-0 p-1"
                                            key={item.productId}
                                        >
                                            <li className="w-50 p-1">
                                                <div className="productimg">
                                                    <div className="productcontet">
                                                        <h4>
                                                            {item.variant === "Veg" || item.variant === "Non Veg" || item.variant === "PRAWNS" ? getVegStatus(item.variant) : getVegStatus(item.vegNonVeg)}

                                                            {item.name}
                                                            {item.variant && ` (${item.variant})`}
                                                            {/*            <a
                                                                href="javascript:void(0);"
                                                                className="ms-2"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#edit">
                                                                <img
                                                                    src={"../assets/img/icons/edit.svg"}
                                                                    alt="img"
                                                                />
                                                            </a>*/}
                                                        </h4>
                                                        <div className="row">
                                                            <div className="col-3 productlinkset">
                                                                <h5>
                                                                    <br/>
                                                                </h5>
                                                            </div>
                                                            <div className="col-8">
                                                                <p
                                                                    onClick={() => {
                                                                        setIsSpecialNoteModalOpen(true);
                                                                        setProductIds(item.productId);
                                                                        setvarient(item.variant);
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={Image}
                                                                        alt="img"
                                                                        style={{
                                                                            height: "15px", width: "25px",
                                                                        }}
                                                                    />
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <p>{item.specialNote}</p>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="increment-decrement">
                                                    <div className="input-groups">
                                                        <input
                                                            type="button"
                                                            value="-"
                                                            onClick={() => {
                                                                events.descQty(item);
                                                            }}
                                                            className="button-minus dec button"
                                                        />
                                                        <input
                                                            type="text"
                                                            name="child"
                                                            value={item.quantity}
                                                            className="quantity-field"
                                                        />
                                                        <input
                                                            type="button"
                                                            value="+"
                                                            onClick={() => {
                                                                events.incQty(item);
                                                            }}
                                                            className="button-plus inc button "
                                                        />
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                {" "}
                                                <strong>Rs. {item.totalAmount}</strong>
                                                <br/>(
                                                <span style={{fontSize: "80%"}}>
                                  Rs. {item.price}
                                </span>
                                                )
                                            </li>
                                        </ul>);
                                    }) : null}
                                </div>
                            </div>
                            <div className="split-card"></div>
                            <div className="card-body pt-0 pb-2 amount-box-inner">
                                <div className="setvalue">
                                    <ul>
                                        <li>
                                            <h5>Sub Total </h5>
                                            <h6>Rs. {state.subTotal}</h6>
                                        </li>
                                        {userType != "captain" && (<li>
                                            <div className="d-flex">
                                                <h5
                                                    className="fake-link"
                                                    onClick={() => {
                                                        setIsDiscountModalOpen(true);
                                                    }}
                                                >
                                                    Apply Discount / Coupon
                                                </h5>
                                                {discountper && (<h5>
                                                    -{discountper || 0}% {couponCode}{" "}
                                                    <i
                                                        className="clearButton"
                                                        onClick={() => {
                                                            setCouponCode("");
                                                            setdiscountper("");
                                                            setDisCouponCode("");
                                                            setDiscountCoupon("");
                                                        }}
                                                    >
                                                        ❌
                                                    </i>
                                                </h5>)}
                                            </div>

                                            <h6>Rs. {state.discountAmount}</h6>
                                        </li>)}
                                        <li>
                                            <div className="d-flex">
                                                <h5>Service Charges (5%)</h5>{" "}
                                                <input
                                                    className="ms-2"
                                                    type="checkbox"
                                                    checked={serviceTaxIncluded}
                                                    onChange={handleCheckboxChange}
                                                    disabled={userType === "captain"}
                                                />
                                            </div>
                                            <h6>Rs. {state.serviceTaxAmount}</h6>
                                        </li>
                                        <li>
                                            <h5>CGST (2.5%) </h5>
                                            <h6>Rs. {state.cgstAmount}</h6>
                                        </li>
                                        <li>
                                            <h5>SGST (2.5%) </h5>
                                            <h6>Rs. {state.sgstAmount}</h6>
                                        </li>

                                        <li className="total-value">
                                            <h5>Total </h5>
                                            <h6>Rs. {state.netAmount}</h6>
                                        </li>
                                    </ul>
                                </div>
                                {currentStatus ? (<>
                                    {currentStatus == "Pending" ? buttonComponent : finalbutton}
                                </>) : (buttonComponent)}
                            </div>
                        </div>
                    </div>
                </div>
                {customerState.visible ? (<AddCustomerDrawerPos
                    onClose={events.hide}
                    onSubmit={(data) => {
                        events.hide();
                        setCustomerMobile(data?.mobileNo || data?.contact || "");
                        setCustomerName(data?.name || "");
                        setCustomerEmail(data?.email || data?.customerEmail || "");
                        setCustomerGst(data?.customerGst || data?.gstIn || "");
                    }}
                    visible={customerState.visible}
                />) : null}

                {choosePaxDrawer.visible ? (<Drawer
                    placement="right"
                    onClose={closePaxDrawer}
                    visible={choosePaxDrawer.visible}
                    width="600px"
                    title={"Select Number Of Customers"}
                >
                    <div>


                        <InputBox title="Select Numbers (1–100)">
                            <select
                                className="form-control"
                                // size={8}
                                value={paxLength}
                                onChange={(e) => {
                                    setPaxLength(Number(e.target.value));
                                    closePaxDrawer();
                                }}
                            >
                                <option key={""} value={""}>
                                    Select Customers
                                </option>
                                {Array.from({length: 100}, (_, i) => (<option key={i + 1} value={i + 1}>
                                    {i + 1}
                                </option>))}
                            </select>
                        </InputBox>
                    </div>
                </Drawer>) : null}

                <div style={{display: "none"}}>
                    {(kotPrintData || (singleOrderData && singleOrderData._id)) ? (<PrintDesign
                        ref={componentRef}
                        singleOrderData={singleOrderData}
                        kotPrintData={kotPrintData}
                    />) : null}
                </div>

                {isPaymentModalOpen && (<Modal
                    visible={isPaymentModalOpen}
                    onClose={() => {
                        setIsPaymentModalOpen(false);
                    }}
                    width={"35%"}
                    title={"Payment"}
                >
                    <h6 className={"mb-2"}>
                        Order Number: {paymentData.orderNo},
                        {/*Amount To Paid: Rs.{" "}*/}
                        {/*{paymentData.totalAmount}*/}
                        Amount To Paid: Rs. {Math.round(paymentData.totalAmount || state.netAmount || 0)}
                        <br/>
                    </h6>
                    <InputBox title={"Payment Option"}>
                        <div className="form-check form-check-inline">
                            <label
                                onClick={() => {
                                    setPaymentOption("payNow");
                                }}
                            >
                                <input
                                    type="radio"
                                    name="paymentOption"
                                    value="payNow"
                                    className="form-check-input"
                                    checked={paymentOption === "payNow"}
                                    onChange={() => setPaymentOption("payNow")}
                                />
                                Pay Now
                            </label>
                        </div>

                        <div className="form-check form-check-inline ms-3">
                            <label
                                onClick={() => {
                                    setPaymentOption("payLater");
                                }}
                            >
                                <input
                                    type="radio"
                                    name="paymentOption"
                                    value="payLater"
                                    className="form-check-input"
                                    checked={paymentOption === "payLater"}
                                    onChange={() => setPaymentOption("payLater")}
                                />
                                Pay Later
                            </label>
                        </div>
                    </InputBox>
                    {paymentOption === "payNow" ? (<>
                        <InputBox title={"Cash Discount"}>
                            <input
                                value={paymentData.cashDiscount}
                                className={"form-control"}
                                type={"number"}
                                onChange={(e) => {
                                    setPaymentData({
                                        ...paymentData, cashDiscount: e.target.value,
                                    });
                                }}
                            />
                        </InputBox>
                        {/*<h6>Final Amount: Rs. {paymentData.finalAmount}</h6>*/}
                        Final Amount:
                        Rs. {Math.round(paymentData.finalAmount || paymentData.totalAmount || 0)}
                        <br/>
                        <InputBox title={"Payment Methods"}>
                            <div className="d-flex align-items-center">
                                <select
                                    className="form-control me-2"
                                    value={selectedPaymentType}
                                    onChange={(e) => setSelectedPaymentType(e.target.value)}
                                    style={{width: "200px"}}
                                >
                                    <option value="">Select Payment</option>

                                    {!selectedPaymentInputs.includes("cash") && (
                                        <option value="cash">Cash</option>)}
                                    {!selectedPaymentInputs.includes("upi") && (
                                        <option value="upi">UPI</option>)}
                                    {!selectedPaymentInputs.includes("card") && (
                                        <option value="card">Card</option>)}
                                </select>

                                <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={() => {
                                        if (!selectedPaymentType) {
                                            notification.warning({message: "Select payment method"});
                                            return;
                                        }

                                        handlePaymentOptionToggle(selectedPaymentType);
                                        setSelectedPaymentType("");
                                    }}
                                >
                                    +
                                </button>
                            </div>
                        </InputBox>

                        <div className={"row"}>
                            {selectedPaymentInputs.includes("cash") && (<div className={"col-md-4"}>
                                <InputBox title={"CASH"}>
                                    <input
                                        value={paymentData.cashAmount || ""}
                                        className={"form-control"}
                                        type={"text"}

                                        onChange={(e) => handlePaymentInputChange("cash", e.target.value)}
                                    />
                                </InputBox>
                            </div>)}

                            {selectedPaymentInputs.includes("upi") && (<div className={"col-md-4"}>
                                <InputBox title={"UPI"}>
                                    <input
                                        value={paymentData.upiAmount || ""}
                                        className={"form-control"}
                                        type={"text"}

                                        onChange={(e) => handlePaymentInputChange("upi", e.target.value)}
                                    />
                                </InputBox>
                            </div>)}

                            {selectedPaymentInputs.includes("card") && (<div className={"col-md-4"}>
                                <InputBox title={"CARD"}>
                                    <input
                                        value={paymentData.cardAmount || ""}
                                        className={"form-control"}
                                        type={"text"}

                                        onChange={(e) => handlePaymentInputChange("card", e.target.value)}
                                    />
                                </InputBox>
                            </div>)}
                        </div>

                        <InputBox title={"Customer Paid"}>
                            <input
                                value={paymentData.customerPaid}
                                className={"form-control"}
                                type={"text"}
                                disabled={true}
                            />
                        </InputBox>


                        <div className={"d-none"}>
                            <InputBox title={"Return To Customer"}>
                                <input
                                    value={paymentData.returnToCustomer}
                                    className={"form-control"}
                                    disabled
                                    type={"number"}
                                />
                            </InputBox>
                            <InputBox title={"Tip"}>
                                <input
                                    value={paymentData.tip}
                                    className={"form-control"}
                                    type={"text"}
                                    onChange={(e) => {
                                        setPaymentData({
                                            ...paymentData, tip: parseFloat(e.target.value),
                                        });
                                    }}
                                />
                            </InputBox>
                            <InputBox title={"Settlement Amount"}>
                                <input
                                    value={paymentData.setteledAmount}
                                    className={"form-control"}
                                    type={"number"}
                                    disabled
                                />
                            </InputBox>
                        </div>
                    </>) : (<>
                        <div className="mt-2">
                            <h6>This order will be saved as Credit.</h6>
                            <h6>Credit Amount: Rs. {state.netAmount}</h6>
                        </div>
                    </>)}
                    <div className={"mt-3 d-md-flex justify-content-md-end"}>
                        <button
                            className={"btn btn-danger"}
                            onClick={() => {
                                setIsPaymentModalOpen(false);
                                setPaymentData({});
                                setPaymentOption("payNow");
                            }}
                        >
                            Cancel
                        </button>

                        <button
                            onClick={() => {
                                // handlePayment();
                                handlePaymentSubmit();
                            }}
                            className={"btn btn-success ms-2"}
                        >
                            Settle Bill & Print
                        </button>
                    </div>
                </Modal>)}
                <Modal
                    visible={isComplementaryReasonModalOpen}
                    title="Complementary Bill Reason"
                    onClose={() => {
                        setIsComplementaryReasonModalOpen(false);
                        setComplementaryReason("");
                    }}
                >
                    <div>
                        <InputBox title={"Reason"}>
                            <input
                                type="text"
                                className="form-control"
                                value={complementaryReason}
                                onChange={(e) => setComplementaryReason(e.target.value)}
                            />
                        </InputBox>

                        {/* ✅ Buttons manually added */}
                        <div className="d-flex justify-content-end mt-3">
                            <button
                                className="btn btn-secondary me-2"
                                onClick={() => {
                                    setIsComplementaryReasonModalOpen(false);
                                    setComplementaryReason("");
                                }}
                            >
                                Cancel
                            </button>

                            <button
                                className="btn btn-success"
                                onClick={() => {
                                    if (!complementaryReason.trim()) {
                                        notification.warning({message: "Please enter reason"});
                                        return;
                                    }

                                    setIsComplementaryBill(true);
                                    setIsComplementaryReasonModalOpen(false);
                                }}
                            >
                                Apply Complimentary
                            </button>
                        </div>
                    </div>
                </Modal>
                {isDiscountModalOpen && (<Modal
                    visible={isDiscountModalOpen}
                    onClose={() => {
                        setdiscountper(0);
                        setIsDiscountModalOpen(false);
                    }}
                    width={modalWidth}
                    title={"Discount"}
                >
                    <InputBox title={"Discount Type"}>
                        <div className="form-check form-check-inline">
                            <label
                                onClick={() => {
                                    handleDiscountChange("discount");
                                    setdiscountper("");
                                    setDisCouponCode("");
                                }}
                            >
                                <input
                                    type="radio"
                                    name="discount"
                                    value="discount"
                                    className="form-check-input"
                                    checked={discountType === "discount"}
                                />
                                Discount
                            </label>
                        </div>
                        <div className="form-check form-check-inline">
                            <label
                                onClick={() => {
                                    handleDiscountChange("coupon");
                                    setdiscountper("");
                                }}
                            >
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="coupon"
                                    value="coupon"
                                    checked={discountType === "coupon"}
                                />
                                Coupon
                            </label>
                        </div>
                    </InputBox>
                    {discountType == "discount" ? (<InputBox title={"Discount %"}>
                        <input
                            value={discountper}
                            className={"form-control w-50"}
                            type={"number"}
                            onChange={(e) => {
                                setdiscountper(e.target.value);
                            }}
                        />
                    </InputBox>) : (<InputBox title={"Coupon Code"}>
                        <input
                            value={disCouponCode}
                            className={"form-control w-50"}
                            type={"text"}
                            onChange={(e) => {
                                setDisCouponCode(e.target.value);
                            }}
                        />
                    </InputBox>)}
                    <div className={"mt-3 d-md-flex justify-content-md-end"}>
                        <button
                            className={"btn btn-danger"}
                            onClick={() => {
                                setdiscountper(0);
                                setIsDiscountModalOpen(false);
                            }}
                        >
                            Cancel
                        </button>

                        {discountType === "coupon" ? (<button
                            onClick={() => {
                                setDiscountCoupon(disCouponCode);
                                setIsDiscountModalOpen(false);
                            }}
                            className={"btn btn-success ms-2"}
                        >
                            Apply
                        </button>) : (<button
                            onClick={handleSaveButtonClick}
                            className={"btn btn-success ms-2"}
                        >
                            Save
                        </button>)}
                    </div>
                </Modal>)}

                {isSpecialNoteModalOpen && (<Modal
                    visible={isSpecialNoteModalOpen}
                    onClose={() => {
                        setIsSpecialNoteModalOpen(false);
                    }}
                    width={modalWidth}
                    title={"Special Note"}
                >
                    <Form>
                        <div className="d-md-flex gap-2">
                            <div className="flex-fill">
                                <InputBox title={"Select Special Note"}>
                                    <select
                                        style={{height: "45px"}}
                                        className="form-control"
                                        value={notes}
                                        onChange={(e) => setNotes(e.target.value)}
                                        disabled={manualNote !== ""}
                                    >
                                        <option value="">Select Special Note</option>
                                        {specialNoteList.map((val) => (
                                            <option key={val._id} value={val.specialNote}>
                                                {val.specialNote}
                                            </option>))}
                                    </select>
                                </InputBox>
                            </div>

                            <div className="flex-fill">
                                <InputBox title={"Manual Note"}>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter manual note"
                                        value={manualNote}
                                        onChange={(e) => setmanualNote(e.target.value)}
                                        disabled={notes !== ""}
                                    />
                                </InputBox>
                            </div>
                        </div>

                        <div className={" d-md-flex justify-content-md-end"}>
                            <button
                                type="submit"
                                className="btn btn-success"
                                onClick={() => handleAddNote()}
                            >
                                Submit
                            </button>
                        </div>
                    </Form>
                </Modal>)}

                {isOldkotModalOpen && (<Modal
                    visible={isOldkotModalOpen}
                    onClose={() => {
                        setIsOldkotModalOpen(false);
                    }}
                    width={modalWidth}
                    title={"Old Kots"}
                >
                    <div className="card-body pt-0 height">
                        <div>
                            {OldKots && OldKots.length ? OldKots.map((item) => {
                                const itemTime = moment(item.time);
                                const currentTime = moment();
                                const timeDifference = currentTime.diff(itemTime, "minutes",);
                                return (<div key={item.kotNo}>
                                    <div
                                        className="dark-background"
                                        style={{
                                            display: "flex", justifyContent: "space-between",
                                        }}>
                                        <h7>
                                            Kot - {item.kotNo} Time -{" "}
                                            {moment(item.time).format("hh:mm A")}{" "}

                                        </h7>

                                        {currentStatus ? (<div style={{display: "flex", alignItems: "center", gap: 8}}>
                                            {currentStatus == "Pending" &&
                                                <UserRights
                                                    user={currentUser}
                                                    userTypes={['md', 'gm', 'cashier', 'admin', 'fbManager']}>
                                                    {canShowTransferMerge && (<button
                                                        type="button"
                                                        className="btn btn-xs btn-warning"
                                                        onClick={() => {
                                                            setTransferKotData({
                                                                orderId: item.orderId,
                                                                kotId: item._id,
                                                            });
                                                            setTransferKotTableName("");
                                                            setTransferKotTableNumber("");
                                                            setTransferKotTableNumbers([]);
                                                            setIsTransferKotModalOpen(true);
                                                        }}>
                                                        Transfer KOT
                                                    </button>)}
                                                </UserRights>
                                            }

                                            <UserRights
                                                user={currentUser}
                                                condition={currentStatus == "Pending" && userType == "cashier"}
                                                userTypes={['gm', 'admin', 'fbManager']}>
                                                <i className="fa fa-edit far"
                                                   style={{cursor: "pointer"}}
                                                   onClick={() => {
                                                       setEditKotModal(true);
                                                       setKotId(item._id);
                                                   }}
                                                />
                                            </UserRights>

                                        </div>) : (buttonComponent)}
                                    </div>

                                    {editKotModal && (<Modal
                                        visible={editKotModal}
                                        onClose={() => {
                                            setEditKotModal(false);
                                        }}
                                        title={"Edit Kot"}
                                    >
                                        <div className={"mt-2"}>
                                            {editKotProducts && editKotProducts.map((product) => {
                                                return (<>
                                                    <ul
                                                        className="product-lists mb-0 p-1"
                                                        key={product._id}
                                                    >
                                                        <li className="w-50">
                                                            <div className="productimg">
                                                                <div
                                                                    className="productcontet">
                                                                    <h6 className={"mb-0"} style={{
                                                                        fontSize: 15,
                                                                        display: "flex",
                                                                        alignItems: "center"
                                                                    }}>
                                                                        {product && product.productId && product.productId.vegNonVeg ? (<>
                                                                            {getVegStatus(product.productId.vegNonVeg,)}
                                                                        </>) : ("")}
                                                                        {product.name}{" "}
                                                                        {product.variant && ` (${product.variant})`}
                                                                    </h6>
                                                                </div>
                                                            </div>
                                                        </li>

                                                        <li>
                                                            <div
                                                                className="increment-decrement">
                                                                <div
                                                                    className="input-groups">
                                                                    <input
                                                                        type="button"
                                                                        value="-"
                                                                        onClick={() => {
                                                                            events.desEditcQty(product,);
                                                                        }}
                                                                        className="button-minus dec button"
                                                                    />
                                                                    <input
                                                                        type="text"
                                                                        name="child"
                                                                        value={product.quantity}
                                                                        className="quantity-field"
                                                                    />
                                                                    <input
                                                                        type="button"
                                                                        value="+"
                                                                        onClick={() => {
                                                                            events.incEditQty(product,);
                                                                        }}
                                                                        className="button-plus inc button "
                                                                    />
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li>
                                              <span
                                                  style={{
                                                      fontSize: "80%",
                                                  }}
                                              >
                                                Rs. {product.price}
                                              </span>
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Rs. {product.totalAmount}
                                                            </strong>
                                                        </li>
                                                    </ul>
                                                </>);
                                            })}

                                            <div className="d-flex justify-content-end mt-2">
                                                <button
                                                    onClick={() => {
                                                        handleEditkot(editKotProducts, "kot");
                                                    }}
                                                    className="btn btn-success"
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </Modal>)}

                                    {item.products.map((product) => {
                                        return (<>
                                            <ul
                                                className="product-lists mb-0 p-1"
                                                key={product._id}
                                            >
                                                <li className="w-50">
                                                    <div className="productimg">
                                                        <div className="productcontet">
                                                            <h4 className={"mb-0"}>
                                                                {product && product.productId && product.productId.vegNonVeg ? (<>
                                                                    {getVegStatus(product.productId.vegNonVeg,)}
                                                                </>) : ("")}
                                                                {product.name}{" "}
                                                                {product.variant && ` (${product.variant})`}
                                                            </h4>

                                                            <div className="d-flex">
                                                                {product.status == "Pending" ? (
                                                                    <div className="productlinkset">
                                                                        <h5>
                                                                            {" "}
                                                                            <br/>
                                                                        </h5>
                                                                    </div>) : (
                                                                    <div className="blue-color">
                                                                        <h5>
                                                                            {" "}
                                                                            <br/>
                                                                        </h5>
                                                                    </div>)}

                                                                {product.priority == "Low" && product.status == "Pending" ? (
                                                                    <i
                                                                        onClick={() => {
                                                                            events.updatePriority(item, product.productId._id,);
                                                                        }}
                                                                        className="buzz">
                                                                        ⚡
                                                                    </i>) : (product.status == "Pending" && (
                                                                    <p className="p-high">High</p>))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>

                                                <li style={{width: 140}}>
                                                    <div className="increment-decrement">
                                                        <div className="input-groups gap-1">
                                                            <div style={{
                                                                fontSize: 11,
                                                                display: "flex",
                                                                gap: 5,
                                                                paddingRight: 50
                                                            }}>
                                                                {product.gst ? <a
                                                                    className={'btn btn-warning btn-xxs rounded-pill'}>Taxable</a> : null}
                                                                {product.discount ?
                                                                    <a className={'btn btn-info btn-xxs rounded-pill'}>Discountable</a> : null}
                                                            </div>
                                                        </div>

                                                    </div>
                                                </li>
                                                <li style={{width: 80}}>
                                                    <div className="increment-decrement">
                                                        <div className="input-groups gap-1">
                                                            <h7>Qty:</h7>
                                                            {product.quantity}
                                                        </div>

                                                    </div>
                                                </li>

                                                <li>
                                                    {" "}
                                                    <strong>Rs. {product.totalAmount}</strong>
                                                    <br/>(
                                                    <span style={{fontSize: "80%"}}>
                                                       Rs. {product.price}
                                                       </span>
                                                    )
                                                </li>
                                            </ul>
                                        </>);
                                    })}
                                </div>);
                            }) : null}
                        </div>
                    </div>
                </Modal>)}

                {isTransferTableModalOpen && (<Modal
                        visible={isTransferTableModalOpen}
                        onClose={() => {
                            setisTransferTableModalOpen(false);
                        }}
                        width={modalWidth}
                        title={"Transfer Table"}
                    >
                        <Form>
                            <div className="form-check form-check-inline">
                                <InputBox title={"Select Table"}>
                                    <select
                                        style={{height: "45px", width: "200px"}}
                                        className="form-control"
                                        value={tableName}
                                        onChange={(e) => setTableName(e.target.value)}
                                        required="true"
                                    >
                                        <option value="">Select Table</option>
                                        {tableList.map((val) => (<option key={val.name} value={val.name}>
                                            {val.name}
                                        </option>))}
                                    </select>
                                </InputBox>
                            </div>
                            <div className="form-check form-check-inline">
                                <InputBox title={"Select Table Number"}>
                                    <select
                                        style={{height: "45px", width: "200px"}}
                                        className="form-control"
                                        value={tableNumber}
                                        onChange={(e) => setTableNumber(e.target.value)}
                                        required="true"
                                    >
                                        <option value="">Select Table Number</option>
                                        {tableNumbers.map((val) => (<option key={val.name} value={val.key}>
                                            {val.name}
                                        </option>))}
                                    </select>
                                </InputBox>
                            </div>

                            <div className={" d-md-flex justify-content-md-end"}>
                                <button
                                    type="submit"
                                    className="btn btn-success"
                                    onClick={() => transferTable(orderId, tableNumber)}
                                >
                                    Submit
                                </button>
                            </div>
                        </Form>
                    </Modal>

                )}
                {isTransferKotModalOpen && (<Modal
                    visible={isTransferKotModalOpen}
                    onClose={() => {
                        setIsTransferKotModalOpen(false);
                    }}
                    width={modalWidth}
                    title={"Transfer KOT"}
                >
                    <Form>
                        <div className="form-check form-check-inline">
                            <InputBox title={"Select Table"}>
                                <select
                                    style={{height: "45px", width: "200px"}}
                                    className="form-control"
                                    value={transferKotTableName}
                                    onChange={(e) => setTransferKotTableName(e.target.value)}
                                >
                                    <option value="">Select Table</option>
                                    {tableList.map((val) => (<option key={val.name} value={val.name}>
                                        {val.name}
                                    </option>))}
                                </select>
                            </InputBox>
                        </div>

                        <div className="form-check form-check-inline">
                            <InputBox title={"Select Table Number"}>
                                <select
                                    style={{height: "45px", width: "200px"}}
                                    className="form-control"
                                    value={transferKotTableNumber}
                                    onChange={(e) => setTransferKotTableNumber(e.target.value)}
                                >
                                    <option value="">Select Table Number</option>
                                    {transferKotTableNumbers.map((val) => (
                                        <option key={val.name} value={val.key}>
                                            {val.name}
                                        </option>))}
                                </select>
                            </InputBox>
                        </div>

                        <div className="d-md-flex justify-content-md-end">
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={transferKot}
                            >
                                Submit
                            </button>
                        </div>
                    </Form>
                </Modal>)}
                {isMergeTableModalOpen && (<Modal
                    visible={isMergeTableModalOpen}
                    onClose={() => setIsMergeTableModalOpen(false)}
                    width={"500px"}
                    title={"Merge Table"}
                >
                    <Form>
                        <div className="form-check form-check-inline">
                            <InputBox title={"Select Running Table"}>
                                <select
                                    style={{height: "45px", width: "200px"}}
                                    className="form-control"
                                    value={selectedMergeTable}
                                    onChange={(e) => setSelectedMergeTable(e.target.value)}
                                >
                                    <option value="">Select Running Table</option>
                                    {/*{runningTables.map((val) => (*/}
                                    {/*    <option key={val.key} value={val.key}>*/}
                                    {/*        {val.name}*/}
                                    {/*    </option>*/}
                                    {/*))}*/}
                                    {runningTables
                                        .filter((val) => String(val.status || "").toLowerCase() === "pending")
                                        .map((val) => (<option key={val.key} value={val.key}>
                                            {val.name}
                                        </option>))}
                                </select>
                            </InputBox>
                        </div>

                        {/* ✅ Submit button */}
                        <div className="mt-3 d-flex justify-content-end">
                            <button
                                className="btn btn-success"
                                onClick={mergeTable}
                                disabled={!selectedMergeTable}   // optional but professional
                            >
                                Submit
                            </button>
                        </div>
                    </Form>
                </Modal>)}
                {isAllKotItemsModalOpen && (
                    <Modal
                        visible={isAllKotItemsModalOpen}
                        onClose={() => setIsAllKotItemsModalOpen(false)}
                        width={modalWidth}
                        title={"Item Summary"}
                    >
                        <Card>
                            <div className="dark-background mb-0">
                                <h7>Punched Item Summary</h7>
                            </div>

                            <ul className="product-lists mb-0 p-2" style={{fontWeight: 700}}>
                                <li className="w-50">Item</li>
                                <li className="text-center">Qty</li>
                                <li className="text-end">Action</li>
                                <li className="text-end">Amount</li>
                            </ul>

                            {getMergedKotItems().length ? (
                                <>
                                    {getMergedKotItems().map((item, index) => {
                                        const itemTotal = Number(item.price || 0) * Number(item.quantity || 0);

                                        return (
                                            <ul className="product-lists mb-0 p-2" key={index}>
                                                <li className="w-50">
                                                    <div className="productimg">
                                                        <div className="productcontet">
                                                            {/*<h4 className="mb-0">*/}
                                                            {/*    {item.vegNonVeg ? getVegStatus(item.vegNonVeg) : ""}*/}
                                                            <h4 className="mb-0">
                                                                {String(item.vegNonVeg || "").toLowerCase() === "egg" ? (
                                                                    <span
                                                                        style={{
                                                                            display: "inline-block",
                                                                            width: 10,
                                                                            height: 10,
                                                                            borderRadius: "50%",
                                                                            backgroundColor: "#f0ad4e",
                                                                            marginRight: 6,
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    item.vegNonVeg ? getVegStatus(item.vegNonVeg) : ""
                                                                )}
                                                                {item.name}
                                                                {item.variant &&
                                                                item.variant !== "Veg" &&
                                                                item.variant !== "Non Veg"
                                                                    ? ` (${item.variant})`
                                                                    : ""}
                                                            </h4>
                                                        </div>
                                                    </div>
                                                </li>

                                                <li className="text-center">
                                                    Qty: <strong>{item.quantity}</strong>
                                                </li>
                                                <li className="text-end">
                                                    {canShowMoveItem && currentUser?.userType !== "captain" && (
                                                        <button
                                                            className="btn btn-success btn-sm"
                                                            onClick={() => {
                                                                handleMoveItemClick(item);
                                                            }}
                                                        >
                                                            Move Item
                                                        </button>
                                                    )}
                                                </li>

                                                <li className="text-end">
                                                    <strong>Rs. {itemTotal.toFixed(2)}</strong>
                                                    <br/>
                                                    <span style={{fontSize: "80%"}}>
                                        (Rs. {Number(item.price || 0).toFixed(2)})
                                    </span>
                                                </li>

                                            </ul>
                                        );
                                    })}

                                    <div className="split-card"></div>

                                    <div className="setvalue">
                                        <ul>
                                            <li>
                                                <h5>Total Qty</h5>
                                                <h6>
                                                    {getMergedKotItems().reduce(
                                                        (sum, item) => sum + Number(item.quantity || 0),
                                                        0
                                                    )}
                                                </h6>
                                            </li>

                                            <li className="total-value">
                                                <h5>Total Amount</h5>
                                                <h6>
                                                    Rs.{" "}
                                                    {getMergedKotItems()
                                                        .reduce((sum, item) => {
                                                            return sum + Number(item.price || 0) * Number(item.quantity || 0);
                                                        }, 0)
                                                        .toFixed(2)}
                                                </h6>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="d-flex justify-content-end mt-3">
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={() => setIsAllKotItemsModalOpen(false)}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <p className="text-center mb-0 p-3">No KOT items found.</p>
                            )}
                        </Card>
                    </Modal>

                )}
                {isMoveItemModalOpen && (
                    <Modal
                        visible={isMoveItemModalOpen}
                        onClose={() => setIsMoveItemModalOpen(false)}
                        width={modalWidth}
                        title="Move Item"
                    >
                        <Card>
                            <div className="mb-2">
                                <strong>{moveItemData?.name}</strong>
                                {moveItemData?.variant ? ` (${moveItemData.variant})` : ""}
                            </div>

                            {/* Quantity */}
                            <div className="mb-3">
                                <label style={{fontWeight: 700, fontSize: 13}}>
                                    Quantity to Move
                                </label>

                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        maxWidth: 220,
                                        border: "1px solid #ddd",
                                        borderRadius: 8,
                                        overflow: "hidden",
                                        marginTop: 6,
                                    }}
                                >
                                    <button
                                        type="button"
                                        style={{
                                            width: 45,
                                            height: 42,
                                            border: "none",
                                            fontSize: 22,
                                            fontWeight: 700,
                                            background: "#f5f5f5",
                                        }}
                                        onClick={() => {
                                            const qty = Number(moveItemQty || 1);
                                            if (qty > 1) setMoveItemQty(qty - 1);
                                        }}
                                    >
                                        -
                                    </button>

                                    <input
                                        type="number"
                                        value={moveItemQty}
                                        min="1"
                                        max={Number(moveItemData?.quantity || 1)}
                                        onChange={(e) => {
                                            const availableQty = Number(moveItemData?.quantity || 0);
                                            let value = Number(e.target.value || "");

                                            if (value > availableQty) value = availableQty;
                                            if (value < 0) value = "";

                                            setMoveItemQty(value);
                                        }}
                                        style={{
                                            width: 90,
                                            height: 42,
                                            border: "none",
                                            textAlign: "center",
                                            fontSize: 18,
                                            fontWeight: 800,
                                            outline: "none",
                                            background: "#fff",
                                        }}
                                    />

                                    <button
                                        type="button"
                                        style={{
                                            width: 45,
                                            height: 42,
                                            border: "none",
                                            fontSize: 22,
                                            fontWeight: 700,
                                            background: "#f5f5f5",
                                        }}
                                        onClick={() => {
                                            const availableQty = Number(moveItemData?.quantity || 0);
                                            const qty = Number(moveItemQty || 0);

                                            if (qty < availableQty) {
                                                setMoveItemQty(qty + 1);
                                            }
                                        }}
                                    >
                                        +
                                    </button>
                                </div>

                                <small style={{color: "#777"}}>
                                    Available: <strong>{moveItemData?.quantity || 0}</strong>
                                </small>
                            </div>
                            {/* Table Name */}
                            <div className="mb-3">
                                <label><b>Select Table</b></label>
                                <select
                                    className="form-control"
                                    value={moveItemTableName}
                                    onChange={(e) => setMoveItemTableName(e.target.value)}
                                >
                                    <option value="">Select Table</option>
                                    {tableList.map((item) => (
                                        <option key={item.name} value={item.name}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Table Number */}
                            <div className="mb-3">
                                <label><b>Select Table Number</b></label>
                                <select
                                    className="form-control"
                                    value={moveItemTableNumber}
                                    onChange={(e) => setMoveItemTableNumber(e.target.value)}
                                >
                                    <option value="">Select Table No</option>
                                    {moveItemTableNumbers.map((item, index) => (
                                        <option key={index} value={item.key}>
                                            {/*{item.key}*/}
                                            {item.key?.toUpperCase().replace("-", " ")}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Buttons */}
                            <div className="d-flex justify-content-end">
                                <button
                                    className="btn btn-danger me-2"
                                    // onClick={() => setIsMoveItemModalOpen(false)}
                                    onClick={() => {
                                        setIsMoveItemModalOpen(false);

                                        // 🔥 clear states
                                        setMoveItemData({});
                                        setMoveItemQty(1);
                                        setMoveItemTableName("");
                                        setMoveItemTableNumber("");
                                        setMoveItemTableNumbers([]);
                                    }}
                                >
                                    Cancel
                                </button>

                                <button
                                    className="btn btn-success"
                                    onClick={() => {
                                        if (!moveItemQty || moveItemQty <= 0) {
                                            notification.warning({message: "Enter valid quantity"});
                                            return;
                                        }

                                        if (!moveItemTableNumber) {
                                            notification.warning({message: "Select table"});
                                            return;
                                        }

                                        // ✅ Call API here
                                        transferKotItem();
                                    }}
                                >
                                    Move Item
                                </button>
                            </div>
                        </Card>
                    </Modal>
                )}
            </div>
        </PageHeader>
    </>);
};
export default PosComponent;

